var Mt = Object.defineProperty;
var vt = (n, s, e) => s in n ? Mt(n, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[s] = e;
var T = (n, s, e) => (vt(n, typeof s != "symbol" ? s + "" : s, e), e);
var pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ut(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Pe = { exports: {} }, $ = typeof Reflect == "object" ? Reflect : null, xe = $ && typeof $.apply == "function" ? $.apply : function(s, e, t) {
  return Function.prototype.apply.call(s, e, t);
}, Y;
$ && typeof $.ownKeys == "function" ? Y = $.ownKeys : Object.getOwnPropertySymbols ? Y = function(s) {
  return Object.getOwnPropertyNames(s).concat(Object.getOwnPropertySymbols(s));
} : Y = function(s) {
  return Object.getOwnPropertyNames(s);
};
function Dt(n) {
  console && console.warn && console.warn(n);
}
var et = Number.isNaN || function(s) {
  return s !== s;
};
function R() {
  R.init.call(this);
}
Pe.exports = R;
Pe.exports.once = jt;
R.EventEmitter = R;
R.prototype._events = void 0;
R.prototype._eventsCount = 0;
R.prototype._maxListeners = void 0;
var Fe = 10;
function ae(n) {
  if (typeof n != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
}
Object.defineProperty(R, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Fe;
  },
  set: function(n) {
    if (typeof n != "number" || n < 0 || et(n))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + n + ".");
    Fe = n;
  }
});
R.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
R.prototype.setMaxListeners = function(s) {
  if (typeof s != "number" || s < 0 || et(s))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + s + ".");
  return this._maxListeners = s, this;
};
function tt(n) {
  return n._maxListeners === void 0 ? R.defaultMaxListeners : n._maxListeners;
}
R.prototype.getMaxListeners = function() {
  return tt(this);
};
R.prototype.emit = function(s) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e.push(arguments[t]);
  var r = s === "error", i = this._events;
  if (i !== void 0)
    r = r && i.error === void 0;
  else if (!r)
    return !1;
  if (r) {
    var o;
    if (e.length > 0 && (o = e[0]), o instanceof Error)
      throw o;
    var a = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw a.context = o, a;
  }
  var l = i[s];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    xe(l, this, e);
  else
    for (var h = l.length, u = ot(l, h), t = 0; t < h; ++t)
      xe(u[t], this, e);
  return !0;
};
function nt(n, s, e, t) {
  var r, i, o;
  if (ae(e), i = n._events, i === void 0 ? (i = n._events = /* @__PURE__ */ Object.create(null), n._eventsCount = 0) : (i.newListener !== void 0 && (n.emit(
    "newListener",
    s,
    e.listener ? e.listener : e
  ), i = n._events), o = i[s]), o === void 0)
    o = i[s] = e, ++n._eventsCount;
  else if (typeof o == "function" ? o = i[s] = t ? [e, o] : [o, e] : t ? o.unshift(e) : o.push(e), r = tt(n), r > 0 && o.length > r && !o.warned) {
    o.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(s) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = n, a.type = s, a.count = o.length, Dt(a);
  }
  return n;
}
R.prototype.addListener = function(s, e) {
  return nt(this, s, e, !1);
};
R.prototype.on = R.prototype.addListener;
R.prototype.prependListener = function(s, e) {
  return nt(this, s, e, !0);
};
function xt() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function st(n, s, e) {
  var t = { fired: !1, wrapFn: void 0, target: n, type: s, listener: e }, r = xt.bind(t);
  return r.listener = e, t.wrapFn = r, r;
}
R.prototype.once = function(s, e) {
  return ae(e), this.on(s, st(this, s, e)), this;
};
R.prototype.prependOnceListener = function(s, e) {
  return ae(e), this.prependListener(s, st(this, s, e)), this;
};
R.prototype.removeListener = function(s, e) {
  var t, r, i, o, a;
  if (ae(e), r = this._events, r === void 0)
    return this;
  if (t = r[s], t === void 0)
    return this;
  if (t === e || t.listener === e)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete r[s], r.removeListener && this.emit("removeListener", s, t.listener || e));
  else if (typeof t != "function") {
    for (i = -1, o = t.length - 1; o >= 0; o--)
      if (t[o] === e || t[o].listener === e) {
        a = t[o].listener, i = o;
        break;
      }
    if (i < 0)
      return this;
    i === 0 ? t.shift() : Ft(t, i), t.length === 1 && (r[s] = t[0]), r.removeListener !== void 0 && this.emit("removeListener", s, a || e);
  }
  return this;
};
R.prototype.off = R.prototype.removeListener;
R.prototype.removeAllListeners = function(s) {
  var e, t, r;
  if (t = this._events, t === void 0)
    return this;
  if (t.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : t[s] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete t[s]), this;
  if (arguments.length === 0) {
    var i = Object.keys(t), o;
    for (r = 0; r < i.length; ++r)
      o = i[r], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (e = t[s], typeof e == "function")
    this.removeListener(s, e);
  else if (e !== void 0)
    for (r = e.length - 1; r >= 0; r--)
      this.removeListener(s, e[r]);
  return this;
};
function rt(n, s, e) {
  var t = n._events;
  if (t === void 0)
    return [];
  var r = t[s];
  return r === void 0 ? [] : typeof r == "function" ? e ? [r.listener || r] : [r] : e ? Bt(r) : ot(r, r.length);
}
R.prototype.listeners = function(s) {
  return rt(this, s, !0);
};
R.prototype.rawListeners = function(s) {
  return rt(this, s, !1);
};
R.listenerCount = function(n, s) {
  return typeof n.listenerCount == "function" ? n.listenerCount(s) : it.call(n, s);
};
R.prototype.listenerCount = it;
function it(n) {
  var s = this._events;
  if (s !== void 0) {
    var e = s[n];
    if (typeof e == "function")
      return 1;
    if (e !== void 0)
      return e.length;
  }
  return 0;
}
R.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Y(this._events) : [];
};
function ot(n, s) {
  for (var e = new Array(s), t = 0; t < s; ++t)
    e[t] = n[t];
  return e;
}
function Ft(n, s) {
  for (; s + 1 < n.length; s++)
    n[s] = n[s + 1];
  n.pop();
}
function Bt(n) {
  for (var s = new Array(n.length), e = 0; e < s.length; ++e)
    s[e] = n[e].listener || n[e];
  return s;
}
function jt(n, s) {
  return new Promise(function(e, t) {
    function r(o) {
      n.removeListener(s, i), t(o);
    }
    function i() {
      typeof n.removeListener == "function" && n.removeListener("error", r), e([].slice.call(arguments));
    }
    at(n, s, i, { once: !0 }), s !== "error" && Wt(n, r, { once: !0 });
  });
}
function Wt(n, s, e) {
  typeof n.on == "function" && at(n, "error", s, e);
}
function at(n, s, e, t) {
  if (typeof n.on == "function")
    t.once ? n.once(s, e) : n.on(s, e);
  else if (typeof n.addEventListener == "function")
    n.addEventListener(s, function r(i) {
      t.once && n.removeEventListener(s, r), e(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof n);
}
var ct = Pe.exports;
const Be = /* @__PURE__ */ Ut(ct);
function lt(n, s) {
  return function() {
    return n.apply(s, arguments);
  };
}
const { toString: qt } = Object.prototype, { getPrototypeOf: Ne } = Object, ce = ((n) => (s) => {
  const e = qt.call(s);
  return n[e] || (n[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), D = (n) => (n = n.toLowerCase(), (s) => ce(s) === n), le = (n) => (s) => typeof s === n, { isArray: z } = Array, J = le("undefined");
function Ht(n) {
  return n !== null && !J(n) && n.constructor !== null && !J(n.constructor) && v(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const ht = D("ArrayBuffer");
function $t(n) {
  let s;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? s = ArrayBuffer.isView(n) : s = n && n.buffer && ht(n.buffer), s;
}
const zt = le("string"), v = le("function"), ut = le("number"), he = (n) => n !== null && typeof n == "object", Gt = (n) => n === !0 || n === !1, Q = (n) => {
  if (ce(n) !== "object")
    return !1;
  const s = Ne(n);
  return (s === null || s === Object.prototype || Object.getPrototypeOf(s) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}, Kt = D("Date"), Jt = D("File"), Vt = D("Blob"), Xt = D("FileList"), Zt = (n) => he(n) && v(n.pipe), Yt = (n) => {
  let s;
  return n && (typeof FormData == "function" && n instanceof FormData || v(n.append) && ((s = ce(n)) === "formdata" || // detect form-data instance
  s === "object" && v(n.toString) && n.toString() === "[object FormData]"));
}, Qt = D("URLSearchParams"), [en, tn, nn, sn] = ["ReadableStream", "Request", "Response", "Headers"].map(D), rn = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function X(n, s, { allOwnKeys: e = !1 } = {}) {
  if (n === null || typeof n > "u")
    return;
  let t, r;
  if (typeof n != "object" && (n = [n]), z(n))
    for (t = 0, r = n.length; t < r; t++)
      s.call(null, n[t], t, n);
  else {
    const i = e ? Object.getOwnPropertyNames(n) : Object.keys(n), o = i.length;
    let a;
    for (t = 0; t < o; t++)
      a = i[t], s.call(null, n[a], a, n);
  }
}
function dt(n, s) {
  s = s.toLowerCase();
  const e = Object.keys(n);
  let t = e.length, r;
  for (; t-- > 0; )
    if (r = e[t], s === r.toLowerCase())
      return r;
  return null;
}
const q = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ft = (n) => !J(n) && n !== q;
function we() {
  const { caseless: n } = ft(this) && this || {}, s = {}, e = (t, r) => {
    const i = n && dt(s, r) || r;
    Q(s[i]) && Q(t) ? s[i] = we(s[i], t) : Q(t) ? s[i] = we({}, t) : z(t) ? s[i] = t.slice() : s[i] = t;
  };
  for (let t = 0, r = arguments.length; t < r; t++)
    arguments[t] && X(arguments[t], e);
  return s;
}
const on = (n, s, e, { allOwnKeys: t } = {}) => (X(s, (r, i) => {
  e && v(r) ? n[i] = lt(r, e) : n[i] = r;
}, { allOwnKeys: t }), n), an = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), cn = (n, s, e, t) => {
  n.prototype = Object.create(s.prototype, t), n.prototype.constructor = n, Object.defineProperty(n, "super", {
    value: s.prototype
  }), e && Object.assign(n.prototype, e);
}, ln = (n, s, e, t) => {
  let r, i, o;
  const a = {};
  if (s = s || {}, n == null)
    return s;
  do {
    for (r = Object.getOwnPropertyNames(n), i = r.length; i-- > 0; )
      o = r[i], (!t || t(o, n, s)) && !a[o] && (s[o] = n[o], a[o] = !0);
    n = e !== !1 && Ne(n);
  } while (n && (!e || e(n, s)) && n !== Object.prototype);
  return s;
}, hn = (n, s, e) => {
  n = String(n), (e === void 0 || e > n.length) && (e = n.length), e -= s.length;
  const t = n.indexOf(s, e);
  return t !== -1 && t === e;
}, un = (n) => {
  if (!n)
    return null;
  if (z(n))
    return n;
  let s = n.length;
  if (!ut(s))
    return null;
  const e = new Array(s);
  for (; s-- > 0; )
    e[s] = n[s];
  return e;
}, dn = ((n) => (s) => n && s instanceof n)(typeof Uint8Array < "u" && Ne(Uint8Array)), fn = (n, s) => {
  const t = (n && n[Symbol.iterator]).call(n);
  let r;
  for (; (r = t.next()) && !r.done; ) {
    const i = r.value;
    s.call(n, i[0], i[1]);
  }
}, pn = (n, s) => {
  let e;
  const t = [];
  for (; (e = n.exec(s)) !== null; )
    t.push(e);
  return t;
}, mn = D("HTMLFormElement"), gn = (n) => n.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, t, r) {
    return t.toUpperCase() + r;
  }
), je = (({ hasOwnProperty: n }) => (s, e) => n.call(s, e))(Object.prototype), yn = D("RegExp"), pt = (n, s) => {
  const e = Object.getOwnPropertyDescriptors(n), t = {};
  X(e, (r, i) => {
    let o;
    (o = s(r, i, n)) !== !1 && (t[i] = o || r);
  }), Object.defineProperties(n, t);
}, Cn = (n) => {
  pt(n, (s, e) => {
    if (v(n) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const t = n[e];
    if (v(t)) {
      if (s.enumerable = !1, "writable" in s) {
        s.writable = !1;
        return;
      }
      s.set || (s.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, wn = (n, s) => {
  const e = {}, t = (r) => {
    r.forEach((i) => {
      e[i] = !0;
    });
  };
  return z(n) ? t(n) : t(String(n).split(s)), e;
}, bn = () => {
}, En = (n, s) => n != null && Number.isFinite(n = +n) ? n : s, me = "abcdefghijklmnopqrstuvwxyz", We = "0123456789", mt = {
  DIGIT: We,
  ALPHA: me,
  ALPHA_DIGIT: me + me.toUpperCase() + We
}, An = (n = 16, s = mt.ALPHA_DIGIT) => {
  let e = "";
  const { length: t } = s;
  for (; n--; )
    e += s[Math.random() * t | 0];
  return e;
};
function Sn(n) {
  return !!(n && v(n.append) && n[Symbol.toStringTag] === "FormData" && n[Symbol.iterator]);
}
const Tn = (n) => {
  const s = new Array(10), e = (t, r) => {
    if (he(t)) {
      if (s.indexOf(t) >= 0)
        return;
      if (!("toJSON" in t)) {
        s[r] = t;
        const i = z(t) ? [] : {};
        return X(t, (o, a) => {
          const l = e(o, r + 1);
          !J(l) && (i[a] = l);
        }), s[r] = void 0, i;
      }
    }
    return t;
  };
  return e(n, 0);
}, In = D("AsyncFunction"), Rn = (n) => n && (he(n) || v(n)) && v(n.then) && v(n.catch), gt = ((n, s) => n ? setImmediate : s ? ((e, t) => (q.addEventListener("message", ({ source: r, data: i }) => {
  r === q && i === e && t.length && t.shift()();
}, !1), (r) => {
  t.push(r), q.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(
  typeof setImmediate == "function",
  v(q.postMessage)
), Pn = typeof queueMicrotask < "u" ? queueMicrotask.bind(q) : typeof process < "u" && process.nextTick || gt, c = {
  isArray: z,
  isArrayBuffer: ht,
  isBuffer: Ht,
  isFormData: Yt,
  isArrayBufferView: $t,
  isString: zt,
  isNumber: ut,
  isBoolean: Gt,
  isObject: he,
  isPlainObject: Q,
  isReadableStream: en,
  isRequest: tn,
  isResponse: nn,
  isHeaders: sn,
  isUndefined: J,
  isDate: Kt,
  isFile: Jt,
  isBlob: Vt,
  isRegExp: yn,
  isFunction: v,
  isStream: Zt,
  isURLSearchParams: Qt,
  isTypedArray: dn,
  isFileList: Xt,
  forEach: X,
  merge: we,
  extend: on,
  trim: rn,
  stripBOM: an,
  inherits: cn,
  toFlatObject: ln,
  kindOf: ce,
  kindOfTest: D,
  endsWith: hn,
  toArray: un,
  forEachEntry: fn,
  matchAll: pn,
  isHTMLForm: mn,
  hasOwnProperty: je,
  hasOwnProp: je,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pt,
  freezeMethods: Cn,
  toObjectSet: wn,
  toCamelCase: gn,
  noop: bn,
  toFiniteNumber: En,
  findKey: dt,
  global: q,
  isContextDefined: ft,
  ALPHABET: mt,
  generateString: An,
  isSpecCompliantForm: Sn,
  toJSONObject: Tn,
  isAsyncFn: In,
  isThenable: Rn,
  setImmediate: gt,
  asap: Pn
};
function b(n, s, e, t, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", s && (this.code = s), e && (this.config = e), t && (this.request = t), r && (this.response = r, this.status = r.status ? r.status : null);
}
c.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: c.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const yt = b.prototype, Ct = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  Ct[n] = { value: n };
});
Object.defineProperties(b, Ct);
Object.defineProperty(yt, "isAxiosError", { value: !0 });
b.from = (n, s, e, t, r, i) => {
  const o = Object.create(yt);
  return c.toFlatObject(n, o, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), b.call(o, n.message, s, e, t, r), o.cause = n, o.name = n.name, i && Object.assign(o, i), o;
};
const Nn = null;
function be(n) {
  return c.isPlainObject(n) || c.isArray(n);
}
function wt(n) {
  return c.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function qe(n, s, e) {
  return n ? n.concat(s).map(function(r, i) {
    return r = wt(r), !e && i ? "[" + r + "]" : r;
  }).join(e ? "." : "") : s;
}
function kn(n) {
  return c.isArray(n) && !n.some(be);
}
const _n = c.toFlatObject(c, {}, null, function(s) {
  return /^is[A-Z]/.test(s);
});
function ue(n, s, e) {
  if (!c.isObject(n))
    throw new TypeError("target must be an object");
  s = s || new FormData(), e = c.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(C, f) {
    return !c.isUndefined(f[C]);
  });
  const t = e.metaTokens, r = e.visitor || u, i = e.dots, o = e.indexes, l = (e.Blob || typeof Blob < "u" && Blob) && c.isSpecCompliantForm(s);
  if (!c.isFunction(r))
    throw new TypeError("visitor must be a function");
  function h(d) {
    if (d === null)
      return "";
    if (c.isDate(d))
      return d.toISOString();
    if (!l && c.isBlob(d))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return c.isArrayBuffer(d) || c.isTypedArray(d) ? l && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function u(d, C, f) {
    let S = d;
    if (d && !f && typeof d == "object") {
      if (c.endsWith(C, "{}"))
        C = t ? C : C.slice(0, -2), d = JSON.stringify(d);
      else if (c.isArray(d) && kn(d) || (c.isFileList(d) || c.endsWith(C, "[]")) && (S = c.toArray(d)))
        return C = wt(C), S.forEach(function(N, O) {
          !(c.isUndefined(N) || N === null) && s.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? qe([C], O, i) : o === null ? C : C + "[]",
            h(N)
          );
        }), !1;
    }
    return be(d) ? !0 : (s.append(qe(f, C, i), h(d)), !1);
  }
  const p = [], A = Object.assign(_n, {
    defaultVisitor: u,
    convertValue: h,
    isVisitable: be
  });
  function E(d, C) {
    if (!c.isUndefined(d)) {
      if (p.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + C.join("."));
      p.push(d), c.forEach(d, function(S, I) {
        (!(c.isUndefined(S) || S === null) && r.call(
          s,
          S,
          c.isString(I) ? I.trim() : I,
          C,
          A
        )) === !0 && E(S, C ? C.concat(I) : [I]);
      }), p.pop();
    }
  }
  if (!c.isObject(n))
    throw new TypeError("data must be an object");
  return E(n), s;
}
function He(n) {
  const s = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(t) {
    return s[t];
  });
}
function ke(n, s) {
  this._pairs = [], n && ue(n, this, s);
}
const bt = ke.prototype;
bt.append = function(s, e) {
  this._pairs.push([s, e]);
};
bt.toString = function(s) {
  const e = s ? function(t) {
    return s.call(this, t, He);
  } : He;
  return this._pairs.map(function(r) {
    return e(r[0]) + "=" + e(r[1]);
  }, "").join("&");
};
function On(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Et(n, s, e) {
  if (!s)
    return n;
  const t = e && e.encode || On, r = e && e.serialize;
  let i;
  if (r ? i = r(s, e) : i = c.isURLSearchParams(s) ? s.toString() : new ke(s, e).toString(t), i) {
    const o = n.indexOf("#");
    o !== -1 && (n = n.slice(0, o)), n += (n.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return n;
}
class Ln {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(s, e, t) {
    return this.handlers.push({
      fulfilled: s,
      rejected: e,
      synchronous: t ? t.synchronous : !1,
      runWhen: t ? t.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(s) {
    this.handlers[s] && (this.handlers[s] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(s) {
    c.forEach(this.handlers, function(t) {
      t !== null && s(t);
    });
  }
}
const $e = Ln, At = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Mn = typeof URLSearchParams < "u" ? URLSearchParams : ke, vn = typeof FormData < "u" ? FormData : null, Un = typeof Blob < "u" ? Blob : null, Dn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Mn,
    FormData: vn,
    Blob: Un
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _e = typeof window < "u" && typeof document < "u", Ee = typeof navigator == "object" && navigator || void 0, xn = _e && (!Ee || ["ReactNative", "NativeScript", "NS"].indexOf(Ee.product) < 0), Fn = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Bn = _e && window.location.href || "http://localhost", jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _e,
  hasStandardBrowserEnv: xn,
  hasStandardBrowserWebWorkerEnv: Fn,
  navigator: Ee,
  origin: Bn
}, Symbol.toStringTag, { value: "Module" })), M = {
  ...jn,
  ...Dn
};
function Wn(n, s) {
  return ue(n, new M.classes.URLSearchParams(), Object.assign({
    visitor: function(e, t, r, i) {
      return M.isNode && c.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, s));
}
function qn(n) {
  return c.matchAll(/\w+|\[(\w*)]/g, n).map((s) => s[0] === "[]" ? "" : s[1] || s[0]);
}
function Hn(n) {
  const s = {}, e = Object.keys(n);
  let t;
  const r = e.length;
  let i;
  for (t = 0; t < r; t++)
    i = e[t], s[i] = n[i];
  return s;
}
function St(n) {
  function s(e, t, r, i) {
    let o = e[i++];
    if (o === "__proto__")
      return !0;
    const a = Number.isFinite(+o), l = i >= e.length;
    return o = !o && c.isArray(r) ? r.length : o, l ? (c.hasOwnProp(r, o) ? r[o] = [r[o], t] : r[o] = t, !a) : ((!r[o] || !c.isObject(r[o])) && (r[o] = []), s(e, t, r[o], i) && c.isArray(r[o]) && (r[o] = Hn(r[o])), !a);
  }
  if (c.isFormData(n) && c.isFunction(n.entries)) {
    const e = {};
    return c.forEachEntry(n, (t, r) => {
      s(qn(t), r, e, 0);
    }), e;
  }
  return null;
}
function $n(n, s, e) {
  if (c.isString(n))
    try {
      return (s || JSON.parse)(n), c.trim(n);
    } catch (t) {
      if (t.name !== "SyntaxError")
        throw t;
    }
  return (e || JSON.stringify)(n);
}
const Oe = {
  transitional: At,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(s, e) {
    const t = e.getContentType() || "", r = t.indexOf("application/json") > -1, i = c.isObject(s);
    if (i && c.isHTMLForm(s) && (s = new FormData(s)), c.isFormData(s))
      return r ? JSON.stringify(St(s)) : s;
    if (c.isArrayBuffer(s) || c.isBuffer(s) || c.isStream(s) || c.isFile(s) || c.isBlob(s) || c.isReadableStream(s))
      return s;
    if (c.isArrayBufferView(s))
      return s.buffer;
    if (c.isURLSearchParams(s))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), s.toString();
    let a;
    if (i) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return Wn(s, this.formSerializer).toString();
      if ((a = c.isFileList(s)) || t.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return ue(
          a ? { "files[]": s } : s,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || r ? (e.setContentType("application/json", !1), $n(s)) : s;
  }],
  transformResponse: [function(s) {
    const e = this.transitional || Oe.transitional, t = e && e.forcedJSONParsing, r = this.responseType === "json";
    if (c.isResponse(s) || c.isReadableStream(s))
      return s;
    if (s && c.isString(s) && (t && !this.responseType || r)) {
      const o = !(e && e.silentJSONParsing) && r;
      try {
        return JSON.parse(s);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? b.from(a, b.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return s;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: M.classes.FormData,
    Blob: M.classes.Blob
  },
  validateStatus: function(s) {
    return s >= 200 && s < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
c.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  Oe.headers[n] = {};
});
const Le = Oe, zn = c.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Gn = (n) => {
  const s = {};
  let e, t, r;
  return n && n.split(`
`).forEach(function(o) {
    r = o.indexOf(":"), e = o.substring(0, r).trim().toLowerCase(), t = o.substring(r + 1).trim(), !(!e || s[e] && zn[e]) && (e === "set-cookie" ? s[e] ? s[e].push(t) : s[e] = [t] : s[e] = s[e] ? s[e] + ", " + t : t);
  }), s;
}, ze = Symbol("internals");
function K(n) {
  return n && String(n).trim().toLowerCase();
}
function ee(n) {
  return n === !1 || n == null ? n : c.isArray(n) ? n.map(ee) : String(n);
}
function Kn(n) {
  const s = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let t;
  for (; t = e.exec(n); )
    s[t[1]] = t[2];
  return s;
}
const Jn = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function ge(n, s, e, t, r) {
  if (c.isFunction(t))
    return t.call(this, s, e);
  if (r && (s = e), !!c.isString(s)) {
    if (c.isString(t))
      return s.indexOf(t) !== -1;
    if (c.isRegExp(t))
      return t.test(s);
  }
}
function Vn(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (s, e, t) => e.toUpperCase() + t);
}
function Xn(n, s) {
  const e = c.toCamelCase(" " + s);
  ["get", "set", "has"].forEach((t) => {
    Object.defineProperty(n, t + e, {
      value: function(r, i, o) {
        return this[t].call(this, s, r, i, o);
      },
      configurable: !0
    });
  });
}
class de {
  constructor(s) {
    s && this.set(s);
  }
  set(s, e, t) {
    const r = this;
    function i(a, l, h) {
      const u = K(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const p = c.findKey(r, u);
      (!p || r[p] === void 0 || h === !0 || h === void 0 && r[p] !== !1) && (r[p || l] = ee(a));
    }
    const o = (a, l) => c.forEach(a, (h, u) => i(h, u, l));
    if (c.isPlainObject(s) || s instanceof this.constructor)
      o(s, e);
    else if (c.isString(s) && (s = s.trim()) && !Jn(s))
      o(Gn(s), e);
    else if (c.isHeaders(s))
      for (const [a, l] of s.entries())
        i(l, a, t);
    else
      s != null && i(e, s, t);
    return this;
  }
  get(s, e) {
    if (s = K(s), s) {
      const t = c.findKey(this, s);
      if (t) {
        const r = this[t];
        if (!e)
          return r;
        if (e === !0)
          return Kn(r);
        if (c.isFunction(e))
          return e.call(this, r, t);
        if (c.isRegExp(e))
          return e.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(s, e) {
    if (s = K(s), s) {
      const t = c.findKey(this, s);
      return !!(t && this[t] !== void 0 && (!e || ge(this, this[t], t, e)));
    }
    return !1;
  }
  delete(s, e) {
    const t = this;
    let r = !1;
    function i(o) {
      if (o = K(o), o) {
        const a = c.findKey(t, o);
        a && (!e || ge(t, t[a], a, e)) && (delete t[a], r = !0);
      }
    }
    return c.isArray(s) ? s.forEach(i) : i(s), r;
  }
  clear(s) {
    const e = Object.keys(this);
    let t = e.length, r = !1;
    for (; t--; ) {
      const i = e[t];
      (!s || ge(this, this[i], i, s, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(s) {
    const e = this, t = {};
    return c.forEach(this, (r, i) => {
      const o = c.findKey(t, i);
      if (o) {
        e[o] = ee(r), delete e[i];
        return;
      }
      const a = s ? Vn(i) : String(i).trim();
      a !== i && delete e[i], e[a] = ee(r), t[a] = !0;
    }), this;
  }
  concat(...s) {
    return this.constructor.concat(this, ...s);
  }
  toJSON(s) {
    const e = /* @__PURE__ */ Object.create(null);
    return c.forEach(this, (t, r) => {
      t != null && t !== !1 && (e[r] = s && c.isArray(t) ? t.join(", ") : t);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([s, e]) => s + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(s) {
    return s instanceof this ? s : new this(s);
  }
  static concat(s, ...e) {
    const t = new this(s);
    return e.forEach((r) => t.set(r)), t;
  }
  static accessor(s) {
    const t = (this[ze] = this[ze] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(o) {
      const a = K(o);
      t[a] || (Xn(r, o), t[a] = !0);
    }
    return c.isArray(s) ? s.forEach(i) : i(s), this;
  }
}
de.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
c.reduceDescriptors(de.prototype, ({ value: n }, s) => {
  let e = s[0].toUpperCase() + s.slice(1);
  return {
    get: () => n,
    set(t) {
      this[e] = t;
    }
  };
});
c.freezeMethods(de);
const U = de;
function ye(n, s) {
  const e = this || Le, t = s || e, r = U.from(t.headers);
  let i = t.data;
  return c.forEach(n, function(a) {
    i = a.call(e, i, r.normalize(), s ? s.status : void 0);
  }), r.normalize(), i;
}
function Tt(n) {
  return !!(n && n.__CANCEL__);
}
function G(n, s, e) {
  b.call(this, n ?? "canceled", b.ERR_CANCELED, s, e), this.name = "CanceledError";
}
c.inherits(G, b, {
  __CANCEL__: !0
});
function It(n, s, e) {
  const t = e.config.validateStatus;
  !e.status || !t || t(e.status) ? n(e) : s(new b(
    "Request failed with status code " + e.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
function Zn(n) {
  const s = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return s && s[1] || "";
}
function Yn(n, s) {
  n = n || 10;
  const e = new Array(n), t = new Array(n);
  let r = 0, i = 0, o;
  return s = s !== void 0 ? s : 1e3, function(l) {
    const h = Date.now(), u = t[i];
    o || (o = h), e[r] = l, t[r] = h;
    let p = i, A = 0;
    for (; p !== r; )
      A += e[p++], p = p % n;
    if (r = (r + 1) % n, r === i && (i = (i + 1) % n), h - o < s)
      return;
    const E = u && h - u;
    return E ? Math.round(A * 1e3 / E) : void 0;
  };
}
function Qn(n, s) {
  let e = 0, t = 1e3 / s, r, i;
  const o = (h, u = Date.now()) => {
    e = u, r = null, i && (clearTimeout(i), i = null), n.apply(null, h);
  };
  return [(...h) => {
    const u = Date.now(), p = u - e;
    p >= t ? o(h, u) : (r = h, i || (i = setTimeout(() => {
      i = null, o(r);
    }, t - p)));
  }, () => r && o(r)];
}
const ne = (n, s, e = 3) => {
  let t = 0;
  const r = Yn(50, 250);
  return Qn((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, l = o - t, h = r(l), u = o <= a;
    t = o;
    const p = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: l,
      rate: h || void 0,
      estimated: h && a && u ? (a - o) / h : void 0,
      event: i,
      lengthComputable: a != null,
      [s ? "download" : "upload"]: !0
    };
    n(p);
  }, e);
}, Ge = (n, s) => {
  const e = n != null;
  return [(t) => s[0]({
    lengthComputable: e,
    total: n,
    loaded: t
  }), s[1]];
}, Ke = (n) => (...s) => c.asap(() => n(...s)), es = M.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const s = M.navigator && /(msie|trident)/i.test(M.navigator.userAgent), e = document.createElement("a");
    let t;
    function r(i) {
      let o = i;
      return s && (e.setAttribute("href", o), o = e.href), e.setAttribute("href", o), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return t = r(window.location.href), function(o) {
      const a = c.isString(o) ? r(o) : o;
      return a.protocol === t.protocol && a.host === t.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), ts = M.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, s, e, t, r, i) {
      const o = [n + "=" + encodeURIComponent(s)];
      c.isNumber(e) && o.push("expires=" + new Date(e).toGMTString()), c.isString(t) && o.push("path=" + t), c.isString(r) && o.push("domain=" + r), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(n) {
      const s = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
      return s ? decodeURIComponent(s[3]) : null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ns(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function ss(n, s) {
  return s ? n.replace(/\/?\/$/, "") + "/" + s.replace(/^\/+/, "") : n;
}
function Rt(n, s) {
  return n && !ns(s) ? ss(n, s) : s;
}
const Je = (n) => n instanceof U ? { ...n } : n;
function H(n, s) {
  s = s || {};
  const e = {};
  function t(h, u, p) {
    return c.isPlainObject(h) && c.isPlainObject(u) ? c.merge.call({ caseless: p }, h, u) : c.isPlainObject(u) ? c.merge({}, u) : c.isArray(u) ? u.slice() : u;
  }
  function r(h, u, p) {
    if (c.isUndefined(u)) {
      if (!c.isUndefined(h))
        return t(void 0, h, p);
    } else
      return t(h, u, p);
  }
  function i(h, u) {
    if (!c.isUndefined(u))
      return t(void 0, u);
  }
  function o(h, u) {
    if (c.isUndefined(u)) {
      if (!c.isUndefined(h))
        return t(void 0, h);
    } else
      return t(void 0, u);
  }
  function a(h, u, p) {
    if (p in s)
      return t(h, u);
    if (p in n)
      return t(void 0, h);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (h, u) => r(Je(h), Je(u), !0)
  };
  return c.forEach(Object.keys(Object.assign({}, n, s)), function(u) {
    const p = l[u] || r, A = p(n[u], s[u], u);
    c.isUndefined(A) && p !== a || (e[u] = A);
  }), e;
}
const Pt = (n) => {
  const s = H({}, n);
  let { data: e, withXSRFToken: t, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: a } = s;
  s.headers = o = U.from(o), s.url = Et(Rt(s.baseURL, s.url), n.params, n.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (c.isFormData(e)) {
    if (M.hasStandardBrowserEnv || M.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [h, ...u] = l ? l.split(";").map((p) => p.trim()).filter(Boolean) : [];
      o.setContentType([h || "multipart/form-data", ...u].join("; "));
    }
  }
  if (M.hasStandardBrowserEnv && (t && c.isFunction(t) && (t = t(s)), t || t !== !1 && es(s.url))) {
    const h = r && i && ts.read(i);
    h && o.set(r, h);
  }
  return s;
}, rs = typeof XMLHttpRequest < "u", is = rs && function(n) {
  return new Promise(function(e, t) {
    const r = Pt(n);
    let i = r.data;
    const o = U.from(r.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: h } = r, u, p, A, E, d;
    function C() {
      E && E(), d && d(), r.cancelToken && r.cancelToken.unsubscribe(u), r.signal && r.signal.removeEventListener("abort", u);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function S() {
      if (!f)
        return;
      const N = U.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), P = {
        data: !a || a === "text" || a === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: N,
        config: n,
        request: f
      };
      It(function(W) {
        e(W), C();
      }, function(W) {
        t(W), C();
      }, P), f = null;
    }
    "onloadend" in f ? f.onloadend = S : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, f.onabort = function() {
      f && (t(new b("Request aborted", b.ECONNABORTED, n, f)), f = null);
    }, f.onerror = function() {
      t(new b("Network Error", b.ERR_NETWORK, n, f)), f = null;
    }, f.ontimeout = function() {
      let O = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const P = r.transitional || At;
      r.timeoutErrorMessage && (O = r.timeoutErrorMessage), t(new b(
        O,
        P.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        n,
        f
      )), f = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in f && c.forEach(o.toJSON(), function(O, P) {
      f.setRequestHeader(P, O);
    }), c.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), a && a !== "json" && (f.responseType = r.responseType), h && ([A, d] = ne(h, !0), f.addEventListener("progress", A)), l && f.upload && ([p, E] = ne(l), f.upload.addEventListener("progress", p), f.upload.addEventListener("loadend", E)), (r.cancelToken || r.signal) && (u = (N) => {
      f && (t(!N || N.type ? new G(null, n, f) : N), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(u), r.signal && (r.signal.aborted ? u() : r.signal.addEventListener("abort", u)));
    const I = Zn(r.url);
    if (I && M.protocols.indexOf(I) === -1) {
      t(new b("Unsupported protocol " + I + ":", b.ERR_BAD_REQUEST, n));
      return;
    }
    f.send(i || null);
  });
}, os = (n, s) => {
  const { length: e } = n = n ? n.filter(Boolean) : [];
  if (s || e) {
    let t = new AbortController(), r;
    const i = function(h) {
      if (!r) {
        r = !0, a();
        const u = h instanceof Error ? h : this.reason;
        t.abort(u instanceof b ? u : new G(u instanceof Error ? u.message : u));
      }
    };
    let o = s && setTimeout(() => {
      o = null, i(new b(`timeout ${s} of ms exceeded`, b.ETIMEDOUT));
    }, s);
    const a = () => {
      n && (o && clearTimeout(o), o = null, n.forEach((h) => {
        h.unsubscribe ? h.unsubscribe(i) : h.removeEventListener("abort", i);
      }), n = null);
    };
    n.forEach((h) => h.addEventListener("abort", i));
    const { signal: l } = t;
    return l.unsubscribe = () => c.asap(a), l;
  }
}, as = os, cs = function* (n, s) {
  let e = n.byteLength;
  if (!s || e < s) {
    yield n;
    return;
  }
  let t = 0, r;
  for (; t < e; )
    r = t + s, yield n.slice(t, r), t = r;
}, ls = async function* (n, s) {
  for await (const e of hs(n))
    yield* cs(e, s);
}, hs = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const s = n.getReader();
  try {
    for (; ; ) {
      const { done: e, value: t } = await s.read();
      if (e)
        break;
      yield t;
    }
  } finally {
    await s.cancel();
  }
}, Ve = (n, s, e, t) => {
  const r = ls(n, s);
  let i = 0, o, a = (l) => {
    o || (o = !0, t && t(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: h, value: u } = await r.next();
        if (h) {
          a(), l.close();
          return;
        }
        let p = u.byteLength;
        if (e) {
          let A = i += p;
          e(A);
        }
        l.enqueue(new Uint8Array(u));
      } catch (h) {
        throw a(h), h;
      }
    },
    cancel(l) {
      return a(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, fe = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Nt = fe && typeof ReadableStream == "function", us = fe && (typeof TextEncoder == "function" ? ((n) => (s) => n.encode(s))(new TextEncoder()) : async (n) => new Uint8Array(await new Response(n).arrayBuffer())), kt = (n, ...s) => {
  try {
    return !!n(...s);
  } catch {
    return !1;
  }
}, ds = Nt && kt(() => {
  let n = !1;
  const s = new Request(M.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return n = !0, "half";
    }
  }).headers.has("Content-Type");
  return n && !s;
}), Xe = 64 * 1024, Ae = Nt && kt(() => c.isReadableStream(new Response("").body)), se = {
  stream: Ae && ((n) => n.body)
};
fe && ((n) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((s) => {
    !se[s] && (se[s] = c.isFunction(n[s]) ? (e) => e[s]() : (e, t) => {
      throw new b(`Response type '${s}' is not supported`, b.ERR_NOT_SUPPORT, t);
    });
  });
})(new Response());
const fs = async (n) => {
  if (n == null)
    return 0;
  if (c.isBlob(n))
    return n.size;
  if (c.isSpecCompliantForm(n))
    return (await new Request(M.origin, {
      method: "POST",
      body: n
    }).arrayBuffer()).byteLength;
  if (c.isArrayBufferView(n) || c.isArrayBuffer(n))
    return n.byteLength;
  if (c.isURLSearchParams(n) && (n = n + ""), c.isString(n))
    return (await us(n)).byteLength;
}, ps = async (n, s) => {
  const e = c.toFiniteNumber(n.getContentLength());
  return e ?? fs(s);
}, ms = fe && (async (n) => {
  let {
    url: s,
    method: e,
    data: t,
    signal: r,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: h,
    headers: u,
    withCredentials: p = "same-origin",
    fetchOptions: A
  } = Pt(n);
  h = h ? (h + "").toLowerCase() : "text";
  let E = as([r, i && i.toAbortSignal()], o), d;
  const C = E && E.unsubscribe && (() => {
    E.unsubscribe();
  });
  let f;
  try {
    if (l && ds && e !== "get" && e !== "head" && (f = await ps(u, t)) !== 0) {
      let P = new Request(s, {
        method: "POST",
        body: t,
        duplex: "half"
      }), x;
      if (c.isFormData(t) && (x = P.headers.get("content-type")) && u.setContentType(x), P.body) {
        const [W, Z] = Ge(
          f,
          ne(Ke(l))
        );
        t = Ve(P.body, Xe, W, Z);
      }
    }
    c.isString(p) || (p = p ? "include" : "omit");
    const S = "credentials" in Request.prototype;
    d = new Request(s, {
      ...A,
      signal: E,
      method: e.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: t,
      duplex: "half",
      credentials: S ? p : void 0
    });
    let I = await fetch(d);
    const N = Ae && (h === "stream" || h === "response");
    if (Ae && (a || N && C)) {
      const P = {};
      ["status", "statusText", "headers"].forEach((De) => {
        P[De] = I[De];
      });
      const x = c.toFiniteNumber(I.headers.get("content-length")), [W, Z] = a && Ge(
        x,
        ne(Ke(a), !0)
      ) || [];
      I = new Response(
        Ve(I.body, Xe, W, () => {
          Z && Z(), C && C();
        }),
        P
      );
    }
    h = h || "text";
    let O = await se[c.findKey(se, h) || "text"](I, n);
    return !N && C && C(), await new Promise((P, x) => {
      It(P, x, {
        data: O,
        headers: U.from(I.headers),
        status: I.status,
        statusText: I.statusText,
        config: n,
        request: d
      });
    });
  } catch (S) {
    throw C && C(), S && S.name === "TypeError" && /fetch/i.test(S.message) ? Object.assign(
      new b("Network Error", b.ERR_NETWORK, n, d),
      {
        cause: S.cause || S
      }
    ) : b.from(S, S && S.code, n, d);
  }
}), Se = {
  http: Nn,
  xhr: is,
  fetch: ms
};
c.forEach(Se, (n, s) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: s });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: s });
  }
});
const Ze = (n) => `- ${n}`, gs = (n) => c.isFunction(n) || n === null || n === !1, _t = {
  getAdapter: (n) => {
    n = c.isArray(n) ? n : [n];
    const { length: s } = n;
    let e, t;
    const r = {};
    for (let i = 0; i < s; i++) {
      e = n[i];
      let o;
      if (t = e, !gs(e) && (t = Se[(o = String(e)).toLowerCase()], t === void 0))
        throw new b(`Unknown adapter '${o}'`);
      if (t)
        break;
      r[o || "#" + i] = t;
    }
    if (!t) {
      const i = Object.entries(r).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = s ? i.length > 1 ? `since :
` + i.map(Ze).join(`
`) : " " + Ze(i[0]) : "as no adapter specified";
      throw new b(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return t;
  },
  adapters: Se
};
function Ce(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new G(null, n);
}
function Ye(n) {
  return Ce(n), n.headers = U.from(n.headers), n.data = ye.call(
    n,
    n.transformRequest
  ), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), _t.getAdapter(n.adapter || Le.adapter)(n).then(function(t) {
    return Ce(n), t.data = ye.call(
      n,
      n.transformResponse,
      t
    ), t.headers = U.from(t.headers), t;
  }, function(t) {
    return Tt(t) || (Ce(n), t && t.response && (t.response.data = ye.call(
      n,
      n.transformResponse,
      t.response
    ), t.response.headers = U.from(t.response.headers))), Promise.reject(t);
  });
}
const Ot = "1.7.7", Me = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, s) => {
  Me[n] = function(t) {
    return typeof t === n || "a" + (s < 1 ? "n " : " ") + n;
  };
});
const Qe = {};
Me.transitional = function(s, e, t) {
  function r(i, o) {
    return "[Axios v" + Ot + "] Transitional option '" + i + "'" + o + (t ? ". " + t : "");
  }
  return (i, o, a) => {
    if (s === !1)
      throw new b(
        r(o, " has been removed" + (e ? " in " + e : "")),
        b.ERR_DEPRECATED
      );
    return e && !Qe[o] && (Qe[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), s ? s(i, o, a) : !0;
  };
};
function ys(n, s, e) {
  if (typeof n != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const t = Object.keys(n);
  let r = t.length;
  for (; r-- > 0; ) {
    const i = t[r], o = s[i];
    if (o) {
      const a = n[i], l = a === void 0 || o(a, i, n);
      if (l !== !0)
        throw new b("option " + i + " must be " + l, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new b("Unknown option " + i, b.ERR_BAD_OPTION);
  }
}
const Te = {
  assertOptions: ys,
  validators: Me
}, j = Te.validators;
class re {
  constructor(s) {
    this.defaults = s, this.interceptors = {
      request: new $e(),
      response: new $e()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(s, e) {
    try {
      return await this._request(s, e);
    } catch (t) {
      if (t instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          t.stack ? i && !String(t.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + i) : t.stack = i;
        } catch {
        }
      }
      throw t;
    }
  }
  _request(s, e) {
    typeof s == "string" ? (e = e || {}, e.url = s) : e = s || {}, e = H(this.defaults, e);
    const { transitional: t, paramsSerializer: r, headers: i } = e;
    t !== void 0 && Te.assertOptions(t, {
      silentJSONParsing: j.transitional(j.boolean),
      forcedJSONParsing: j.transitional(j.boolean),
      clarifyTimeoutError: j.transitional(j.boolean)
    }, !1), r != null && (c.isFunction(r) ? e.paramsSerializer = {
      serialize: r
    } : Te.assertOptions(r, {
      encode: j.function,
      serialize: j.function
    }, !0)), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let o = i && c.merge(
      i.common,
      i[e.method]
    );
    i && c.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete i[d];
      }
    ), e.headers = U.concat(o, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(C) {
      typeof C.runWhen == "function" && C.runWhen(e) === !1 || (l = l && C.synchronous, a.unshift(C.fulfilled, C.rejected));
    });
    const h = [];
    this.interceptors.response.forEach(function(C) {
      h.push(C.fulfilled, C.rejected);
    });
    let u, p = 0, A;
    if (!l) {
      const d = [Ye.bind(this), void 0];
      for (d.unshift.apply(d, a), d.push.apply(d, h), A = d.length, u = Promise.resolve(e); p < A; )
        u = u.then(d[p++], d[p++]);
      return u;
    }
    A = a.length;
    let E = e;
    for (p = 0; p < A; ) {
      const d = a[p++], C = a[p++];
      try {
        E = d(E);
      } catch (f) {
        C.call(this, f);
        break;
      }
    }
    try {
      u = Ye.call(this, E);
    } catch (d) {
      return Promise.reject(d);
    }
    for (p = 0, A = h.length; p < A; )
      u = u.then(h[p++], h[p++]);
    return u;
  }
  getUri(s) {
    s = H(this.defaults, s);
    const e = Rt(s.baseURL, s.url);
    return Et(e, s.params, s.paramsSerializer);
  }
}
c.forEach(["delete", "get", "head", "options"], function(s) {
  re.prototype[s] = function(e, t) {
    return this.request(H(t || {}, {
      method: s,
      url: e,
      data: (t || {}).data
    }));
  };
});
c.forEach(["post", "put", "patch"], function(s) {
  function e(t) {
    return function(i, o, a) {
      return this.request(H(a || {}, {
        method: s,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  re.prototype[s] = e(), re.prototype[s + "Form"] = e(!0);
});
const te = re;
class ve {
  constructor(s) {
    if (typeof s != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(i) {
      e = i;
    });
    const t = this;
    this.promise.then((r) => {
      if (!t._listeners)
        return;
      let i = t._listeners.length;
      for (; i-- > 0; )
        t._listeners[i](r);
      t._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((a) => {
        t.subscribe(a), i = a;
      }).then(r);
      return o.cancel = function() {
        t.unsubscribe(i);
      }, o;
    }, s(function(i, o, a) {
      t.reason || (t.reason = new G(i, o, a), e(t.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(s) {
    if (this.reason) {
      s(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(s) : this._listeners = [s];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(s) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(s);
    e !== -1 && this._listeners.splice(e, 1);
  }
  toAbortSignal() {
    const s = new AbortController(), e = (t) => {
      s.abort(t);
    };
    return this.subscribe(e), s.signal.unsubscribe = () => this.unsubscribe(e), s.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let s;
    return {
      token: new ve(function(r) {
        s = r;
      }),
      cancel: s
    };
  }
}
const Cs = ve;
function ws(n) {
  return function(e) {
    return n.apply(null, e);
  };
}
function bs(n) {
  return c.isObject(n) && n.isAxiosError === !0;
}
const Ie = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ie).forEach(([n, s]) => {
  Ie[s] = n;
});
const Es = Ie;
function Lt(n) {
  const s = new te(n), e = lt(te.prototype.request, s);
  return c.extend(e, te.prototype, s, { allOwnKeys: !0 }), c.extend(e, s, null, { allOwnKeys: !0 }), e.create = function(r) {
    return Lt(H(n, r));
  }, e;
}
const k = Lt(Le);
k.Axios = te;
k.CanceledError = G;
k.CancelToken = Cs;
k.isCancel = Tt;
k.VERSION = Ot;
k.toFormData = ue;
k.AxiosError = b;
k.Cancel = k.CanceledError;
k.all = function(s) {
  return Promise.all(s);
};
k.spread = ws;
k.isAxiosError = bs;
k.mergeConfig = H;
k.AxiosHeaders = U;
k.formToJSON = (n) => St(c.isHTMLForm(n) ? new FormData(n) : n);
k.getAdapter = _t.getAdapter;
k.HttpStatusCode = Es;
k.default = k;
const As = k;
class m {
  constructor(s) {
    T(this, "appId", "");
    if (!s)
      throw new Error("TalkPlus HttpClient requires appId");
    this.appId = s;
  }
  static New(s) {
    if (!s)
      throw new Error("TalkPlus HttpClient requires appId");
    return new m(s);
  }
  urlWithQueries(s, e = {}) {
    let t = "";
    const r = Object.keys(e);
    for (let i = 0; i < r.length; i++) {
      i === 0 ? t += "?" : t += "&";
      const o = r[i];
      o && (Array.isArray(e[o]) ? e[o].forEach((a, l) => {
        t += `${o}=${a}`, l !== e.length - 1 && (t += "&");
      }) : t += `${o}=${e[o]}`);
    }
    return s + t;
  }
  buildHeader({ contentType: s, sessionToken: e }) {
    return {
      "app-id": this.appId,
      "content-type": s || "",
      Authorization: e ? `Bearer ${e}` : ""
    };
  }
  get({ sessionToken: s, url: e, queries: t }) {
    return this.makeRequest({
      sessionToken: s,
      url: this.urlWithQueries(e, t),
      method: "GET"
    });
  }
  put({ sessionToken: s, url: e, jsonData: t, formData: r }) {
    return this.makeRequest({
      sessionToken: s,
      url: e,
      method: "PUT",
      jsonData: t,
      formData: r
    });
  }
  post({ url: s, sessionToken: e, jsonData: t, formData: r }) {
    return this.makeRequest({
      url: s,
      method: "POST",
      sessionToken: e,
      jsonData: t,
      formData: r
    });
  }
  delete({ sessionToken: s, url: e, jsonData: t }) {
    return this.makeRequest({
      sessionToken: s,
      url: e,
      method: "DELETE",
      jsonData: t
    });
  }
  makeRequest({ sessionToken: s, url: e, method: t, jsonData: r, formData: i }) {
    const o = {
      url: e,
      method: t
    };
    if (r && !i && (o.data = r), i) {
      o.headers = this.buildHeader({ contentType: "multipart/form-data", sessionToken: s });
      const l = new FormData();
      Object.keys(i).forEach((h) => {
        h === "data" ? l.append("data", JSON.stringify(i.data)) : Array.isArray(i[h]) ? l.append(h, i[h].join(",")) : l.append(h, i[h]);
      }), o.data = l;
    } else
      o.headers = this.buildHeader({ contentType: "application/json", sessionToken: s });
    const a = As(o);
    return new Promise((l, h) => {
      a.then((u) => u.status === 500 ? { success: !1, data: u.data } : u.status !== 200 ? { success: !1, data: new Error(`request failed. status: ${u.status}`) } : { success: !0, data: u.data }).then(async (u) => {
        if (u.success)
          l(u.data);
        else {
          const p = u.data && u.data.then && typeof u.data.then == "function";
          h(p ? await u.data : u.data);
        }
      }).catch((u) => {
        var p;
        h((p = u == null ? void 0 : u.response) == null ? void 0 : p.data);
      });
    });
  }
}
const Ss = "https://api.talkplus.io", Ts = "wss://ws.api.talkplus.io", y = "v1.4", Re = "0.5.6", _ = {
  LOGIN_TOKEN: `%host%/${y}/users/login/token`,
  LOGIN_ANONYMOUS: `%host%/${y}/users/login/anonymous`,
  UPDATE_USER: `%host%/${y}/users/update`,
  DELETE_USER: `%host%/${y}/users/delete`,
  REGISTER_FCM_TOKEN: `%host%/${y}/users/register/fcm`,
  REGISTER_PUSHKIT_TOKEN: `%host%/${y}/users/register/pushkit`,
  ENABLE_PUSH_NOTIFICATION: `%host%/${y}/users/settings/push/enable`,
  DISABLE_PUSH_NOTIFICATION: `%host%/${y}/users/settings/push/disable`,
  NOTIFICATIONS: `%host%/${y}/users/notifications`,
  WEBSOCKET_NOTIFICATIONS: `%host%/${y}/users/ws/notifications`,
  WEBRTC_AUTH: `%host%/${y}/users/webrtc/auth`,
  LOGOUT: `%host%/${y}/users/logout`,
  BLOCKED: `%host%/${y}/users/blocked`,
  BLOCK: `%host%/${y}/users/block`,
  UNBLOCK: `%host%/${y}/users/unblock`
}, w = {
  GET_LIST: `%host%/${y}/channels`,
  CREATE: `%host%/${y}/channels/create`,
  GET: `%host%/${y}/channels/%s`,
  UPDATE: `%host%/${y}/channels/%s`,
  DELETE: `%host%/${y}/channels/%s`,
  MEMBERS: `%host%/${y}/channels/%s/members`,
  ADD_MEMBERS: `%host%/${y}/channels/%s/members/add`,
  REMOVE_MEMBERS: `%host%/${y}/channels/%s/members/remove`,
  BANNED_USERS: `%host%/${y}/channels/%s/members/banned`,
  BAN_MEMBERS: `%host%/${y}/channels/%s/members/ban`,
  UNBAN_MEMBERS: `%host%/${y}/channels/%s/members/unban`,
  MUTED_MEMBERS: `%host%/${y}/channels/%s/members/muted`,
  MUTE_MEMBERS: `%host%/${y}/channels/%s/members/mute`,
  UNMUTE_MEMBERS: `%host%/${y}/channels/%s/members/unmute`,
  MUTED_PEERS: `%host%/${y}/channels/%s/peer/muted`,
  MUTE_PEERS: `%host%/${y}/channels/%s/peer/mute`,
  UNMUTE_PEERS: `%host%/${y}/channels/%s/peer/unmute`,
  CHANNEL_PRIVATE_DATA: `%host%/${y}/channels/%s/privateData`,
  CHANNEL_PRIVATE_TAG: `%host%/${y}/channels/%s/privateTag`,
  CHANNEL_MEMBER: `%host%/${y}/channels/%s/members/%s`,
  CHANNEL_MEMBER_INFO: `%host%/${y}/channels/%s/memberInfo`,
  ENABLE_CHANNEL_PUSH_NOTI: `%host%/${y}/channels/%s/push/enable`,
  DISABLE_CHANNEL_PUSH_NOTI: `%host%/${y}/channels/%s/push/disable`,
  CHANNEL_PUSH_NOTI_SETTINGS: `%host%/${y}/channels/%s/push/settings`,
  MARK_READ: `%host%/${y}/channels/%s/markread`,
  MARK_READ_ALL: `%host%/${y}/channels/markread/all`,
  GET_MESSAGES: `%host%/${y}/channels/%s/messages`,
  GET_FILE_MESSAGES: `%host%/${y}/channels/%s/messages/files`,
  SEND_MESSAGE: `%host%/${y}/channels/%s/messages/send`,
  GET_MESSAGE: `%host%/${y}/channels/%s/messages/%s`,
  TRANSLATE_MESSAGE: `%host%/${y}/channels/%s/messages/%s/translate`,
  DELETE_MESSAGE: `%host%/${y}/channels/%s/messages/%s`,
  ADD_MESSAGE_REACTIONS: `%host%/${y}/channels/%s/messages/%s/reactions`,
  DELETE_MESSAGE_REACTIONS: `%host%/${y}/channels/%s/messages/%s/reactions/%s`,
  FREEZE: `%host%/${y}/channels/%s/freeze`,
  UNFREEZE: `%host%/${y}/channels/%s/unfreeze`,
  HIDE: `%host%/${y}/channels/%s/hide`,
  SHOW: `%host%/${y}/channels/%s/show`,
  HIDE_ALL: `%host%/${y}/channels/hide/all`,
  JOIN: `%host%/${y}/channels/%s/join`,
  JOIN_INVITATION: `%host%/${y}/channels/%s/join/invitation`,
  LEAVE: `%host%/${y}/channels/%s/leave`,
  UNREAD_COUNT: `%host%/${y}/channels/unread/count`,
  TRANSFER_OWNERSHIP: `%host%/${y}/channels/%s/transfer/ownership`
};
function g(n) {
  return n.replace("%host%", Ss);
}
function Is(n) {
  return n.replace("%host%", Ts);
}
var ie = { exports: {} };
/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
ie.exports;
(function(n, s) {
  (function(e) {
    var t = s, r = n && n.exports == t && n, i = typeof pe == "object" && pe;
    (i.global === i || i.window === i) && (e = i);
    var o = function(d) {
      this.message = d;
    };
    o.prototype = new Error(), o.prototype.name = "InvalidCharacterError";
    var a = function(d) {
      throw new o(d);
    }, l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = /[\t\n\f\r ]/g, u = function(d) {
      d = String(d).replace(h, "");
      var C = d.length;
      C % 4 == 0 && (d = d.replace(/==?$/, ""), C = d.length), (C % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(d)) && a(
        "Invalid character: the string to be decoded is not correctly encoded."
      );
      for (var f = 0, S, I, N = "", O = -1; ++O < C; )
        I = l.indexOf(d.charAt(O)), S = f % 4 ? S * 64 + I : I, f++ % 4 && (N += String.fromCharCode(
          255 & S >> (-2 * f & 6)
        ));
      return N;
    }, p = function(d) {
      d = String(d), /[^\0-\xFF]/.test(d) && a(
        "The string to be encoded contains characters outside of the Latin1 range."
      );
      for (var C = d.length % 3, f = "", S = -1, I, N, O, P, x = d.length - C; ++S < x; )
        I = d.charCodeAt(S) << 16, N = d.charCodeAt(++S) << 8, O = d.charCodeAt(++S), P = I + N + O, f += l.charAt(P >> 18 & 63) + l.charAt(P >> 12 & 63) + l.charAt(P >> 6 & 63) + l.charAt(P & 63);
      return C == 2 ? (I = d.charCodeAt(S) << 8, N = d.charCodeAt(++S), P = I + N, f += l.charAt(P >> 10) + l.charAt(P >> 4 & 63) + l.charAt(P << 2 & 63) + "=") : C == 1 && (P = d.charCodeAt(S), f += l.charAt(P >> 2) + l.charAt(P << 4 & 63) + "=="), f;
    }, A = {
      encode: p,
      decode: u,
      version: "1.0.0"
    };
    if (t && !t.nodeType)
      if (r)
        r.exports = A;
      else
        for (var E in A)
          A.hasOwnProperty(E) && (t[E] = A[E]);
    else
      e.base64 = A;
  })(pe);
})(ie, ie.exports);
var Rs = ie.exports;
class Ue extends ct.EventEmitter {
  constructor() {
    super(...arguments);
    T(this, "userId", "");
    T(this, "sessionId", "");
    T(this, "sessionToken", "");
    T(this, "__isLoggedInCached", !1);
    T(this, "__sessionTokenExpiresAt", 0);
  }
  clearSession() {
    this.userId = "", this.sessionId = "", this.sessionToken = "", this.__isLoggedInCached = !1, this.__sessionTokenExpiresAt = 0;
  }
  updateSession({
    userId: e,
    sessionId: t,
    sessionToken: r
  }) {
    this.userId = e, this.sessionId = t, this.sessionToken = r;
  }
  getSessionToken() {
    return this.sessionToken;
  }
  isLoggedIn() {
    if (!!!this.sessionToken)
      return !1;
    if (this.__sessionTokenExpiresAt > 0)
      return this.__isLoggedInCached;
    const t = this.parseJwt(this.sessionToken);
    if (!t.exp)
      return !0;
    const r = Math.floor(Date.now() / 1e3);
    return this.__isLoggedInCached = r <= t.exp, this.__sessionTokenExpiresAt = t.exp, this.__isLoggedInCached;
  }
  generateDeviceId() {
    return `web::${navigator.userAgent}||${(/* @__PURE__ */ new Date()).getTime()}`;
  }
  wrapWithCallback(e, t, r) {
    const i = e.bind(this), o = new Promise((a, l) => {
      try {
        return Array.isArray(t) ? a(i(...t)) : a(i(t));
      } catch (h) {
        return l(h);
      }
    });
    return r && typeof r == "function" ? o.then((a) => r(null, a)).catch(async (a) => a && a.then && typeof a.then == "function" ? r(await a) : r(a)) : o;
  }
  wrapWithCallbackLoginRequired(e, t, r) {
    if (!this.isLoggedIn()) {
      const i = new Promise(
        (o, a) => a(new Error("talkplus client: not logged in!"))
      );
      if (r && typeof r == "function") {
        i.then(() => r(null)).catch((o) => {
          r(o);
        });
        return;
      }
      return i;
    }
    return this.wrapWithCallback(e, t, r);
  }
  parseJwt(e) {
    var o;
    const t = e.split(".");
    if (!t.length)
      return "";
    var r = (o = t[1]) == null ? void 0 : o.replace(/-/g, "+").replace(/_/g, "/");
    if (!r)
      return "";
    var i = decodeURIComponent(Rs.decode(r).split("").map(function(a) {
      return "%" + ("00" + a.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(i);
  }
}
class Ps extends Ue {
  constructor(e) {
    super();
    T(this, "appId", "");
    if (!e)
      throw new Error("TalkPlus Auth requires appId for initialization");
    this.appId = e;
  }
  async loginWithTokenAsync(e, t, r) {
    const i = t.deviceType ? t.deviceType : "web", o = {
      deviceId: `${i}_${y}_loginWithToken_${e}`,
      deviceType: i,
      sdkVersion: Re,
      userId: t.userId,
      loginToken: t.loginToken,
      username: t.username,
      profileImageUrl: t.profileImageUrl,
      translationTargetLanguage: t.translationTargetLanguage,
      data: t.data,
      file: t.file
    };
    let a;
    return o.file ? a = await m.New(this.appId).post({
      url: g(_.LOGIN_TOKEN),
      formData: o
    }) : a = await m.New(this.appId).post({
      url: g(_.LOGIN_TOKEN),
      jsonData: o
    }), r.forEach((l) => {
      l.updateSession({
        userId: a.user.id,
        sessionId: a.sessionId,
        sessionToken: a.sessionToken
      });
    }), a;
  }
  loginWithToken(e, t, r, i) {
    return this.wrapWithCallback(
      this.loginWithTokenAsync,
      [e, t, r],
      i
    );
  }
  async loginAnonymousAsync(e, t, r) {
    const i = t.deviceType ? t.deviceType : "web", o = {
      deviceId: `${i}_${y}_loginAnonymous_${e}`,
      deviceType: i,
      sdkVersion: Re,
      userId: t.userId,
      username: t.username,
      profileImageUrl: t.profileImageUrl,
      translationTargetLanguage: t.translationTargetLanguage,
      data: t.data,
      file: t.file
    };
    let a;
    return o.file ? a = await m.New(this.appId).post({
      url: g(_.LOGIN_ANONYMOUS),
      formData: o
    }) : a = await m.New(this.appId).post({
      url: g(_.LOGIN_ANONYMOUS),
      jsonData: o
    }), r.forEach((l) => {
      l.updateSession({
        userId: a.user.id,
        sessionId: a.sessionId,
        sessionToken: a.sessionToken
      });
    }), a;
  }
  loginAnonymous(e, t, r, i) {
    return this.wrapWithCallback(
      this.loginAnonymousAsync,
      [e, t, r],
      i
    );
  }
  async updateUserAsync(e) {
    return e.file ? m.New(this.appId).put({
      sessionToken: this.getSessionToken(),
      url: g(_.UPDATE_USER),
      formData: e
    }) : m.New(this.appId).put({
      sessionToken: this.getSessionToken(),
      url: g(_.UPDATE_USER),
      jsonData: e
    });
  }
  updateUser(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.updateUserAsync,
      e,
      t
    );
  }
  async deleteUserAsync() {
    const e = await m.New(this.appId).delete({
      sessionToken: this.getSessionToken(),
      url: g(_.DELETE_USER)
    });
    return this.clearSession(), e;
  }
  deleteUser(e) {
    return this.wrapWithCallbackLoginRequired(
      this.deleteUserAsync,
      {},
      e
    );
  }
  async enablePushNotificationAsync() {
    return await m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.ENABLE_PUSH_NOTIFICATION)
    });
  }
  enablePushNotification(e) {
    return this.wrapWithCallbackLoginRequired(
      this.enablePushNotificationAsync,
      {},
      e
    );
  }
  async registerFcmTokenAsync({
    fcmToken: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.REGISTER_FCM_TOKEN),
      jsonData: { fcmToken: e }
    });
  }
  registerFcmToken(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.registerFcmTokenAsync,
      e,
      t
    );
  }
  async registerPushKitTokenAsync({
    pushKitToken: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.REGISTER_PUSHKIT_TOKEN),
      jsonData: { pushKitToken: e }
    });
  }
  registerPushKitToken(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.registerPushKitTokenAsync,
      e,
      t
    );
  }
  async disablePushNotificationAsync() {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.DISABLE_PUSH_NOTIFICATION)
    });
  }
  disablePushNotification(e) {
    return this.wrapWithCallbackLoginRequired(
      this.disablePushNotificationAsync,
      {},
      e
    );
  }
  async logoutAsync() {
    if (!this.isLoggedIn())
      return this.clearSession(), {};
    const e = await m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.LOGOUT)
    });
    return this.clearSession(), e;
  }
  logout(e) {
    return this.wrapWithCallback(this.logoutAsync, [], e);
  }
  async getWebRTCAuthAsync() {
    return await m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: g(_.WEBRTC_AUTH)
    });
  }
  getWebRTCAuth(e) {
    return this.wrapWithCallback(this.getWebRTCAuthAsync, [], e);
  }
  async getBlockedUsersAsync({
    lastUserId: e
  }) {
    return await m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: g(_.BLOCKED),
      queries: e ? { lastUserId: e } : {}
    });
  }
  getBlockedUsers(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getBlockedUsersAsync,
      e,
      t
    );
  }
  async blockUserAsync({ userId: e }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.BLOCK),
      jsonData: { userId: e }
    });
  }
  blockUser(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.blockUserAsync,
      e,
      t
    );
  }
  async unblockUserAsync({ userId: e }) {
    return await m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(_.UNBLOCK),
      jsonData: { userId: e }
    });
  }
  unblockUser(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.unblockUserAsync,
      e,
      t
    );
  }
  async getNotificationAsync(e) {
    const t = await m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: e
    }), { notification: r } = t;
    if (["message", "messageDeleted"].includes(r.type))
      return {
        type: r.type,
        data: {
          channel: r.data.channel,
          message: r.data.message
        }
      };
    if (["channelAdded", "channelChanged", "channelRemoved"].includes(
      r.type
    ))
      return {
        type: r.type,
        data: {
          channel: r.data.channel
        }
      };
    if (["memberAdded", "memberLeft"].includes(r.type))
      return {
        type: r.type,
        data: {
          channel: r.data.channel,
          users: r.data.users
        }
      };
    if (["memberMuted", "memberUnmuted"].includes(r.type))
      return {
        type: r.type,
        data: {
          channel: r.data.channel,
          users: r.data.users
        }
      };
    throw new Error(
      `Unsupported TalkPlus notification type: ${r.type}`
    );
  }
  getNotification(e, t) {
    return this.wrapWithCallback(
      this.getNotificationAsync,
      e,
      t
    );
  }
}
var V = /* @__PURE__ */ ((n) => (n.Public = "public", n.Hidden = "hidden", n.Default = "default", n))(V || {}), oe = /* @__PURE__ */ ((n) => (n.Name = "name", n))(oe || {});
class Ns extends Ue {
  constructor(e) {
    super();
    T(this, "appId", "");
    if (!e)
      throw new Error("TalkPlus Channel requires appId for initialization");
    this.appId = e;
  }
  async getListAsync(e) {
    const {
      type: t,
      lastChannelId: r,
      filter: i,
      query: o,
      members: a,
      limit: l,
      category: h,
      subcategory: u,
      isFrozen: p,
      hasUnread: A,
      privateTag: E,
      summarize: d,
      order: C
    } = e, f = r ? { lastChannelId: r } : {};
    return !t || !Object.values(V).includes(t) ? f.type = V.Default : f.type = t, !i || !Object.values(oe).includes(i) ? f.filter = oe.Name : f.filter = i, typeof p < "u" && (f.isFrozen = p), typeof A < "u" && (f.hasUnread = A), o && (f.query = o), h && (f.category = h), u && (f.subcategory = u), E && (f.privateTag = E), a && Array.isArray(a) && a.length && (f.members = a), d && (f.summarize = d), C && (f.order = C), l && (f.limit = l), m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: g(w.GET_LIST),
      queries: f
    });
  }
  async getList(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getListAsync,
      e,
      t
    );
  }
  async createAsync({
    channelId: e,
    name: t,
    type: r,
    invitationCode: i,
    members: o,
    reuseChannel: a,
    imageUrl: l,
    maxMemberCount: h,
    hideMessagesBeforeJoin: u,
    data: p,
    category: A,
    subcategory: E
  }) {
    const d = {
      channelId: e,
      name: t,
      type: r,
      invitationCode: i,
      members: o,
      reuseChannel: a,
      imageUrl: l,
      maxMemberCount: h,
      hideMessagesBeforeJoin: u,
      category: A,
      subcategory: E
    };
    return p && (d.data = p), m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(w.CREATE),
      jsonData: d
    });
  }
  create({
    channelId: e,
    name: t,
    type: r,
    invitationCode: i,
    members: o,
    reuseChannel: a,
    imageUrl: l,
    maxMemberCount: h,
    hideMessagesBeforeJoin: u,
    data: p,
    category: A,
    subcategory: E
  }, d) {
    return this.wrapWithCallbackLoginRequired(
      this.createAsync,
      {
        channelId: e,
        name: t,
        type: r,
        invitationCode: i,
        members: o,
        reuseChannel: a,
        imageUrl: l,
        maxMemberCount: h,
        hideMessagesBeforeJoin: u,
        data: p,
        category: A,
        subcategory: E
      },
      d
    );
  }
  getAsync({
    channelId: e
  }) {
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.GET), e)
    });
  }
  async get({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getAsync,
      { channelId: e },
      t
    );
  }
  async updateAsync({
    channelId: e,
    name: t,
    invitationCode: r,
    imageUrl: i,
    maxMemberCount: o,
    hideMessagesBeforeJoin: a,
    data: l,
    category: h,
    subcategory: u
  }) {
    const p = {
      channelId: e,
      name: t,
      invitationCode: r,
      imageUrl: i,
      maxMemberCount: o,
      hideMessagesBeforeJoin: a,
      category: h,
      subcategory: u
    };
    return l && (p.data = l), m.New(this.appId).put({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.UPDATE), e),
      jsonData: p
    });
  }
  async update({
    channelId: e,
    name: t,
    invitationCode: r,
    imageUrl: i,
    maxMemberCount: o,
    hideMessagesBeforeJoin: a,
    data: l,
    category: h,
    subcategory: u
  }, p) {
    return this.wrapWithCallbackLoginRequired(
      this.updateAsync,
      {
        channelId: e,
        name: t,
        invitationCode: r,
        imageUrl: i,
        maxMemberCount: o,
        hideMessagesBeforeJoin: a,
        data: l,
        category: h,
        subcategory: u
      },
      p
    );
  }
  async deleteAsync({
    channelId: e
  }) {
    return m.New(this.appId).delete({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.DELETE), e)
    });
  }
  async delete({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.deleteAsync,
      { channelId: e },
      t
    );
  }
  async getChannelMembersAsync({
    channelId: e,
    lastUserId: t
  }) {
    const r = t ? { lastUserId: t } : {};
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MEMBERS), e),
      queries: r
    });
  }
  async getChannelMembers({ channelId: e, lastUserId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.getChannelMembersAsync,
      { channelId: e, lastUserId: t },
      r
    );
  }
  async getChannelMemberAsync({
    channelId: e,
    userId: t
  }) {
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.CHANNEL_MEMBER),
        e,
        t
      )
    });
  }
  async getChannelMember({ channelId: e, userId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.getChannelMemberAsync,
      { channelId: e, userId: t },
      r
    );
  }
  async addChannelMembersAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.ADD_MEMBERS), e),
      jsonData: { members: t }
    });
  }
  async addChannelMembers({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.addChannelMembersAsync,
      { channelId: e, members: t },
      r
    );
  }
  async removeChannelMembersAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.REMOVE_MEMBERS), e),
      jsonData: { members: t }
    });
  }
  async removeChannelMembers({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.removeChannelMembersAsync,
      { channelId: e, members: t },
      r
    );
  }
  async getBannedUsersFromChannelAsync({
    channelId: e,
    lastUserId: t
  }) {
    const r = t ? { lastUserId: t } : {};
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.BANNED_USERS), e),
      queries: r
    });
  }
  async getBannedUsersFromChannel({ channelId: e, lastUserId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.getBannedUsersFromChannelAsync,
      { channelId: e, lastUserId: t },
      r
    );
  }
  async banUsersFromChannelAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.BAN_MEMBERS), e),
      jsonData: { members: t }
    });
  }
  async banUsersFromChannel({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.banUsersFromChannelAsync,
      { channelId: e, members: t },
      r
    );
  }
  async unbanUsersFromChannelAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.UNBAN_MEMBERS), e),
      jsonData: { members: t }
    });
  }
  async unbanUsersFromChannel({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.unbanUsersFromChannelAsync,
      { channelId: e, members: t },
      r
    );
  }
  async getMutedChannelMembersAsync({
    channelId: e,
    lastUserId: t
  }) {
    const r = t ? { lastUserId: t } : {};
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MUTED_MEMBERS), e),
      queries: r
    });
  }
  async getMutedChannelMembers({ channelId: e, lastUserId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.getMutedChannelMembersAsync,
      { channelId: e, lastUserId: t },
      r
    );
  }
  async muteChannelMembersAsync({
    channelId: e,
    members: t,
    expireInMinutes: r
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MUTE_MEMBERS), e),
      jsonData: { members: t, expireInMinutes: r }
    });
  }
  async muteChannelMembers({ channelId: e, members: t, expireInMinutes: r }, i) {
    return this.wrapWithCallbackLoginRequired(
      this.muteChannelMembersAsync,
      { channelId: e, members: t, expireInMinutes: r },
      i
    );
  }
  async unmuteChannelMembersAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.UNMUTE_MEMBERS), e),
      jsonData: { members: t }
    });
  }
  async unmuteChannelMembers({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.unmuteChannelMembersAsync,
      { channelId: e, members: t },
      r
    );
  }
  async getMutedPeersAsync({
    channelId: e,
    lastUserId: t
  }) {
    const r = t ? { lastUserId: t } : {};
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MUTED_PEERS), e),
      queries: r
    });
  }
  async getMutedPeers({ channelId: e, lastUserId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.getMutedPeersAsync,
      { channelId: e, lastUserId: t },
      r
    );
  }
  async mutePeersAsync({
    channelId: e,
    members: t,
    expireInMinutes: r
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MUTE_PEERS), e),
      jsonData: { members: t, expireInMinutes: r }
    });
  }
  async mutePeers({ channelId: e, members: t, expireInMinutes: r }, i) {
    return this.wrapWithCallbackLoginRequired(
      this.mutePeersAsync,
      { channelId: e, members: t, expireInMinutes: r },
      i
    );
  }
  async unmutePeersAsync({
    channelId: e,
    members: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.UNMUTE_PEERS), e),
      jsonData: { members: t }
    });
  }
  async unmutePeers({ channelId: e, members: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.unmutePeersAsync,
      { channelId: e, members: t },
      r
    );
  }
  async enablePushNotiAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.ENABLE_CHANNEL_PUSH_NOTI),
        e
      )
    });
  }
  async enablePushNoti({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.enablePushNotiAsync,
      { channelId: e },
      t
    );
  }
  async disablePushNotiAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.DISABLE_CHANNEL_PUSH_NOTI),
        e
      )
    });
  }
  async disablePushNoti({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.disablePushNotiAsync,
      { channelId: e },
      t
    );
  }
  async getChannelPushNotificationSettingsAsync({
    channelId: e
  }) {
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.CHANNEL_PUSH_NOTI_SETTINGS),
        e
      )
    });
  }
  async getChannelPushNotificationSettings({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getChannelPushNotificationSettingsAsync,
      { channelId: e },
      t
    );
  }
  async updateChannelPushNotificationSettingsAsync({
    channelId: e,
    aosSound: t,
    iosSound: r
  }) {
    const i = {
      channelId: e
    };
    return t !== null && (i.pushNotificationSoundAos = t), r !== null && (i.pushNotificationSoundIos = r), m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.CHANNEL_PUSH_NOTI_SETTINGS),
        e
      ),
      jsonData: i
    });
  }
  async updateChannelPushNotificationSettings({
    channelId: e,
    aosSound: t,
    iosSound: r
  }, i) {
    return this.wrapWithCallbackLoginRequired(
      this.updateChannelPushNotificationSettingsAsync,
      { channelId: e, aosSound: t, iosSound: r },
      i
    );
  }
  async markChannelAsReadAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.MARK_READ), e)
    });
  }
  async markChannelAsRead({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.markChannelAsReadAsync,
      { channelId: e },
      t
    );
  }
  async markAllChannelsAsReadAsync() {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(w.MARK_READ_ALL)
    });
  }
  async markAllChannelsAsRead(e) {
    return this.wrapWithCallbackLoginRequired(
      this.markAllChannelsAsReadAsync,
      null,
      e
    );
  }
  async getMessageAsync({
    channelId: e,
    messageId: t,
    translationTargetLanguage: r
  }) {
    let i = {
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.GET_MESSAGE),
        e,
        t
      )
    };
    return r && (i.queries = { translationTargetLanguage: r }), m.New(this.appId).get(i);
  }
  async getMessage(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getMessageAsync,
      e,
      t
    );
  }
  async getMessagesAsync({
    channelId: e,
    lastMessageId: t,
    limit: r,
    order: i,
    translationTargetLanguage: o
  }) {
    const a = t ? { channelId: e, lastMessageId: t } : { channelId: e };
    return r && (a.limit = r), i && (a.order = i), o && (a.translationTargetLanguage = o), m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.GET_MESSAGES), e),
      queries: a
    });
  }
  async getMessages(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getMessagesAsync,
      e,
      t
    );
  }
  async getFileMessagesAsync({
    channelId: e,
    lastMessageId: t,
    limit: r,
    order: i,
    translationTargetLanguage: o
  }) {
    const a = t ? { lastMessageId: t, channelId: e } : { channelId: e };
    return r && (a.limit = r), i && (a.order = i), o && (a.translationTargetLanguage = o), m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.GET_FILE_MESSAGES), e),
      queries: a
    });
  }
  async getFileMessages(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getFileMessagesAsync,
      e,
      t
    );
  }
  async sendMessageAsync({
    channelId: e,
    type: t,
    text: r,
    fileUrl: i,
    data: o,
    mentions: a,
    translationTargetLanguages: l,
    file: h,
    parentMessageId: u
  }) {
    const E = {
      channelId: e,
      type: t,
      text: r || "",
      fileUrl: i || ""
    };
    return o && (E.data = o), a && (E.mentions = a), l && (E.translationTargetLanguages = l), u && (E.parentMessageId = u), h ? (E.file = h, m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.SEND_MESSAGE), e),
      formData: E
    })) : m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.SEND_MESSAGE), e),
      jsonData: E
    });
  }
  async sendMessage({
    channelId: e,
    type: t,
    text: r,
    fileUrl: i,
    data: o,
    mentions: a,
    translationTargetLanguages: l,
    file: h,
    parentMessageId: u
  }, p) {
    return this.wrapWithCallbackLoginRequired(
      this.sendMessageAsync,
      {
        channelId: e,
        type: t,
        text: r,
        fileUrl: i,
        data: o,
        mentions: a,
        translationTargetLanguages: l,
        file: h,
        parentMessageId: u
      },
      p
    );
  }
  async translateMessageAsync({
    channelId: e,
    messageId: t,
    targetLanguages: r
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      jsonData: { targetLanguages: r },
      url: this.sprintf(
        g(w.TRANSLATE_MESSAGE),
        e,
        t
      )
    });
  }
  async translateMessage(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.translateMessageAsync,
      e,
      t
    );
  }
  async deleteMessageAsync({
    channelId: e,
    messageId: t
  }) {
    return m.New(this.appId).delete({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.DELETE_MESSAGE),
        e,
        t
      )
    });
  }
  async deleteMessage({ channelId: e, messageId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.deleteMessageAsync,
      { channelId: e, messageId: t },
      r
    );
  }
  async addMessageReactionAsync({
    channelId: e,
    messageId: t,
    reaction: r
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.ADD_MESSAGE_REACTIONS),
        e,
        t
      ),
      jsonData: { reaction: r }
    });
  }
  async addMessageReaction({ channelId: e, messageId: t, reaction: r }, i) {
    return this.wrapWithCallbackLoginRequired(
      this.addMessageReactionAsync,
      { channelId: e, messageId: t, reaction: r },
      i
    );
  }
  async removeMessageReactionAsync({
    channelId: e,
    messageId: t,
    reaction: r
  }) {
    return m.New(this.appId).delete({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(
        g(w.DELETE_MESSAGE_REACTIONS),
        e,
        t,
        r
      )
    });
  }
  async removeMessageReaction({ channelId: e, messageId: t, reaction: r }, i) {
    return this.wrapWithCallbackLoginRequired(
      this.removeMessageReactionAsync,
      { channelId: e, messageId: t, reaction: r },
      i
    );
  }
  async updateChannelPrivateTagAsync({
    channelId: e,
    privateTag: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.CHANNEL_PRIVATE_TAG), e),
      jsonData: { privateTag: t }
    });
  }
  async updateChannelPrivateTag({ channelId: e, privateTag: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.updateChannelPrivateTagAsync,
      { channelId: e, privateTag: t },
      r
    );
  }
  async updateChannelPrivateDataAsync({
    channelId: e,
    privateData: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.CHANNEL_PRIVATE_DATA), e),
      jsonData: { privateData: t }
    });
  }
  async updateChannelPrivateData({ channelId: e, privateData: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.updateChannelPrivateDataAsync,
      { channelId: e, privateData: t },
      r
    );
  }
  async updateChannelMemberInfoAsync({
    channelId: e,
    memberInfo: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.CHANNEL_MEMBER_INFO), e),
      jsonData: { memberInfo: t }
    });
  }
  async updateChannelMemberInfo({ channelId: e, memberInfo: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.updateChannelMemberInfoAsync,
      { channelId: e, memberInfo: t },
      r
    );
  }
  async freezeChannelAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.FREEZE), e)
    });
  }
  async freezeChannel({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.freezeChannelAsync,
      { channelId: e },
      t
    );
  }
  async unfreezeChannelAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.UNFREEZE), e)
    });
  }
  async unfreezeChannel({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.unfreezeChannelAsync,
      { channelId: e },
      t
    );
  }
  async hideChannelAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.HIDE), e)
    });
  }
  async hideChannel({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.hideChannelAsync,
      { channelId: e },
      t
    );
  }
  async showChannelAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.SHOW), e)
    });
  }
  async showChannel({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.showChannelAsync,
      { channelId: e },
      t
    );
  }
  async hideAllChannelsAsync() {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: g(w.HIDE_ALL)
    });
  }
  async hideAllChannels(e) {
    return this.wrapWithCallbackLoginRequired(
      this.hideAllChannelsAsync,
      null,
      e
    );
  }
  async joinChannelAsync({
    channelId: e
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.JOIN), e)
    });
  }
  async joinChannel({ channelId: e }, t) {
    return this.wrapWithCallbackLoginRequired(
      this.joinChannelAsync,
      { channelId: e },
      t
    );
  }
  async joinChannelByInvitationCodeAsync({
    channelId: e,
    invitationCode: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.JOIN_INVITATION), e),
      jsonData: { invitationCode: t }
    });
  }
  async joinChannelByInvitationCode({ channelId: e, invitationCode: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.joinChannelByInvitationCodeAsync,
      { channelId: e, invitationCode: t },
      r
    );
  }
  async leaveChannelAsync({
    channelId: e,
    deleteChannelIfEmpty: t
  }) {
    const r = {
      channelId: e,
      deleteChannelIfEmpty: t
    };
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.LEAVE), e),
      jsonData: r
    });
  }
  async leaveChannel({ channelId: e, deleteChannelIfEmpty: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.leaveChannelAsync,
      { channelId: e, deleteChannelIfEmpty: t },
      r
    );
  }
  async getUnreadCountAsync(e) {
    const t = {};
    if (e) {
      const { category: r, subcategory: i, privateTag: o } = e;
      r && (t.category = r), i && (t.subcategory = i), o && (t.privateTag = o);
    }
    return m.New(this.appId).get({
      sessionToken: this.getSessionToken(),
      url: g(w.UNREAD_COUNT),
      queries: t
    });
  }
  async getUnreadCount(e, t) {
    return this.wrapWithCallbackLoginRequired(
      this.getUnreadCountAsync,
      e,
      t
    );
  }
  async transferChannelOwnershipAsync({
    channelId: e,
    userId: t
  }) {
    return m.New(this.appId).post({
      sessionToken: this.getSessionToken(),
      url: this.sprintf(g(w.TRANSFER_OWNERSHIP), e),
      jsonData: { userId: t }
    });
  }
  async transferChannelOwnership({ channelId: e, userId: t }, r) {
    return this.wrapWithCallbackLoginRequired(
      this.transferChannelOwnershipAsync,
      { channelId: e, userId: t },
      r
    );
  }
  getMessageUnreadCount({
    channel: e,
    message: t
  }) {
    if (!this.userId)
      throw new Error("TalkPlus user not logged in");
    let r = 0;
    return (e.members || []).forEach((i) => {
      this.userId !== i.id && i.lastReadAt < t.createdAt && r++;
    }), r;
  }
  sprintf(e, ...t) {
    let r = e;
    return t.forEach((i) => {
      r = r.replace("%s", i);
    }), r;
  }
}
var ks = /* @__PURE__ */ ((n) => (n.Private = "private", n.Public = "public", n.InvitationOnly = "invitationOnly", n.Broadcast = "broadcast", n.SuperPublic = "super_public", n.SuperPrivate = "super_private", n.SuperBroadcast = "super_broadcast", n.Brand = "brand", n))(ks || {}), _s = /* @__PURE__ */ ((n) => (n.Text = "text", n.Hidden = "hidden", n.Admin = "admin", n.AdminHidden = "admin_hidden", n.Bot = "bot", n.BotHidden = "bot_hidden", n.Custom = "custom", n.Brand = "brand", n))(_s || {}), Os = /* @__PURE__ */ ((n) => (n.ChannelAdded = "channelAdded", n.ChannelRemoved = "channelRemoved", n.ChannelChanged = "channelChanged", n.MemberAdded = "memberAdded", n.MemberLeft = "memberLeft", n.MemberMuted = "memberMuted", n.MemberUnmuted = "memberUnmuted", n.MemberBanned = "memberBanned", n.MemberUnbanned = "memberUnbanned", n.Message = "message", n.MessageDeleted = "messageDeleted", n))(Os || {}), L = /* @__PURE__ */ ((n) => (n.Offer = "offer", n.Answer = "answer", n.Candidate = "candidate", n.EndCall = "endCall", n))(L || {}), F = /* @__PURE__ */ ((n) => (n[n.Unknown = 0] = "Unknown", n[n.Completed = 1] = "Completed", n[n.Declined = 2] = "Declined", n[n.Canceled = 3] = "Canceled", n))(F || {}), B = /* @__PURE__ */ ((n) => (n.Unknown = "unknown", n.Completed = "completed", n.Declined = "declined", n.Canceled = "canceled", n))(B || {});
const Ls = 3e4;
class vs extends Ue {
  constructor({ appId: e, disableEvents: t }) {
    super();
    T(this, "appId", "");
    T(this, "disableEvents", !1);
    T(this, "deviceId", "");
    T(this, "auth");
    T(this, "channel");
    T(this, "latestNotiTimestamp", 0);
    T(this, "lastExponentialBackOffInMS", 1);
    T(this, "wsConn");
    T(this, "rtcPeerConn");
    T(this, "rtcPeerUuid");
    T(this, "rtcPeerChannelId");
    T(this, "rtcPeerCallerId");
    T(this, "rtcPeerCalleeId");
    T(this, "rtcPeerIncomingOfferPayload");
    T(this, "rtcPeerIncomingCustomData");
    T(this, "rtcPeerConnectionInProgress", !1);
    T(this, "rtcPeerConnectionMade", !1);
    T(this, "rtcPeerIceCandidates");
    T(this, "publicChannelsEventListener");
    T(this, "call");
    if (!e)
      throw new Error("TalkPlus Client requires appId for initialization");
    this.appId = e, this.deviceId = this.generateDeviceId(), this.disableEvents = t || !1, this.auth = new Ps(e), this.channel = new Ns(e), this.publicChannelsEventListener = new Be(), this.call = new Be();
  }
  getVersion() {
    return Re;
  }
  updateSession(e) {
    if (this.clearSession(), super.updateSession(e), this.auth.updateSession(e), this.channel.updateSession(e), !this.disableEvents) {
      const t = {
        appId: this.appId,
        sessionId: this.sessionId,
        sessionToken: this.sessionToken
      };
      this.startWebSocketConn(t);
    }
  }
  startWebSocketConn({
    appId: e,
    sessionId: t,
    sessionToken: r
  }) {
    let i = Is(_.WEBSOCKET_NOTIFICATIONS);
    this.latestNotiTimestamp && (i += `?timestamp=${this.latestNotiTimestamp}`), this.wsConn = new WebSocket(i), this.wsConn.onopen = (o) => {
      var l;
      const a = JSON.stringify({
        appId: e,
        sessionId: t,
        sessionToken: r
      });
      (l = this.wsConn) == null || l.send(a);
    }, this.wsConn.onclose = (o) => {
      this.lastExponentialBackOffInMS >= Ls ? this.lastExponentialBackOffInMS = 10 : this.lastExponentialBackOffInMS > 1e4 ? this.lastExponentialBackOffInMS += 3e3 : this.lastExponentialBackOffInMS += 1e3;
      const a = {
        appId: this.appId,
        sessionId: this.sessionId,
        sessionToken: this.sessionToken
      };
      this.wsConn.wsConnTimer = setTimeout(
        () => this.startWebSocketConn(a),
        this.lastExponentialBackOffInMS
      );
    }, this.wsConn.onmessage = this.websocketNotificationHandler.bind(this);
  }
  websocketNotificationHandler(e) {
    let t;
    try {
      t = JSON.parse(e.data);
    } catch (h) {
      console.error(h);
      return;
    }
    const { error: r, type: i, data: o } = t, a = i ? i.toLowerCase() : "";
    this.latestNotiTimestamp = t.timestamp;
    const l = Object.values(
      L
    ).includes(i);
    try {
      if (r)
        this.handleError(t);
      else if (l)
        switch (i) {
          case L.Candidate:
            this.handleWebRTCIceCandidate(o.webRtc);
            break;
          case L.Offer:
            this.handleWebRTCOffer(o.webRtc);
            break;
          case L.Answer:
            this.handleWebRTCAnswer(o.webRtc);
            break;
          case L.EndCall:
            this.handleWebRTCEndCall(o.webRtc);
            break;
        }
      else
        o.isPublicChannelEvent ? (this.publicChannelsEventListener.emit("event", o), this.publicChannelsEventListener.emit(a, o)) : (this.emit("event", o), this.emit(a, o));
    } catch {
    }
  }
  handleError(e) {
    this.rtcPeerConnectionMade = !1, this.call.emit("error", {
      channelId: this.rtcPeerChannelId,
      callerId: this.rtcPeerCallerId,
      calleeId: this.rtcPeerCalleeId,
      error: e
    }), this.resetWebRTCDetails();
  }
  clearSession() {
    super.clearSession(), this.auth.clearSession(), this.channel.clearSession(), this.wsConn && (clearInterval(this.wsConn.wsConnTimer), this.wsConn.close()), this.resetWebRTCDetails();
  }
  getNotification(e) {
    let t = e.talkplus;
    return typeof t == "string" && (t = JSON.parse(t)), this.auth.getNotification(t.notificationLink);
  }
  /*
   --------------
   AUTH start
   --------------
  */
  loginWithToken(e, t) {
    return e.file && (e.profileImageUrl = void 0), this.auth.loginWithToken(this.deviceId, e, [this], t);
  }
  loginAnonymous(e, t) {
    return e.file && (e.profileImageUrl = void 0), this.auth.loginAnonymous(this.deviceId, e, [this], t);
  }
  updateUser(e, t) {
    return e.file && (e.profileImageUrl = void 0), this.auth.updateUser(e, t);
  }
  deleteUser(e) {
    const t = this.auth.deleteUser(e);
    return this.clearSession(), t;
  }
  registerFcmToken(e, t) {
    return this.auth.registerFcmToken(e, t);
  }
  registerPushKitToken(e, t) {
    return this.auth.registerPushKitToken(e, t);
  }
  enablePushNotification(e) {
    return this.auth.enablePushNotification(e);
  }
  disablePushNotification(e) {
    return this.auth.disablePushNotification(e);
  }
  logout(e) {
    const t = this.auth.logout(e);
    return this.clearSession(), t;
  }
  getBlockedUsers(e, t) {
    return this.auth.getBlockedUsers(e, t);
  }
  blockUser(e, t) {
    return this.auth.blockUser(e, t);
  }
  unblockUser(e, t) {
    return this.auth.unblockUser(e, t);
  }
  /*
   --------------
   AUTH end
   --------------
  */
  // /*
  //   --------------
  //   CHANNEL start
  //   --------------
  //  */
  getChannels(e, t) {
    return this.channel.getList(e, t);
  }
  searchChannels(e, t) {
    const { query: r, members: i } = e;
    if (!r && (!Array.isArray(i) || !i.length))
      throw new Error(
        "Searching channels requires either a non-empty query or a list of member IDs to match"
      );
    return e.filter = oe.Name, this.channel.getList(e, t);
  }
  getHiddenChannels(e, t) {
    return e.type = V.Hidden, this.channel.getList(e, t);
  }
  getPublicChannels(e, t) {
    return e.type = V.Public, this.channel.getList(e, t);
  }
  createChannel(e, t) {
    return this.channel.create(e, t);
  }
  getChannel(e, t) {
    return this.channel.get(e, t);
  }
  updateChannel(e, t) {
    return this.channel.update(e, t);
  }
  deleteChannel(e, t) {
    return this.channel.delete(e, t);
  }
  getChannelMembers(e, t) {
    return this.channel.getChannelMembers(e, t);
  }
  getChannelMember(e, t) {
    return this.channel.getChannelMember(e, t);
  }
  addChannelMembers(e, t) {
    return this.channel.addChannelMembers(e, t);
  }
  removeChannelMembers(e, t) {
    return this.channel.removeChannelMembers(e, t);
  }
  getBannedUsersFromChannel(e, t) {
    return this.channel.getBannedUsersFromChannel(e, t);
  }
  /**
   * @deprecated Use getBannedUsersFromChannel() instead
   */
  getBannedChannelUsers(e, t) {
    return this.channel.getBannedUsersFromChannel(e, t);
  }
  banUsersFromChannel(e, t) {
    return this.channel.banUsersFromChannel(e, t);
  }
  /**
   * @deprecated Use banUsersFromChannel() instead
   */
  banChannelMembers(e, t) {
    return this.channel.banUsersFromChannel(e, t);
  }
  unbanUsersFromChannel(e, t) {
    return this.channel.unbanUsersFromChannel(e, t);
  }
  /**
   * @deprecated Use unbanUsersFromChannel() instead
   */
  unbanChannelMembers(e, t) {
    return this.channel.unbanUsersFromChannel(e, t);
  }
  getMutedChannelMembers(e, t) {
    return this.channel.getMutedChannelMembers(e, t);
  }
  muteChannelMembers(e, t) {
    return this.channel.muteChannelMembers(e, t);
  }
  unmuteChannelMembers(e, t) {
    return this.channel.unmuteChannelMembers(e, t);
  }
  getMutedPeers(e, t) {
    return this.channel.getMutedPeers(e, t);
  }
  mutePeers(e, t) {
    return this.channel.mutePeers(e, t);
  }
  unmutePeers(e, t) {
    return this.channel.unmutePeers(e, t);
  }
  enableChannelPushNotification(e, t) {
    return this.channel.enablePushNoti(e, t);
  }
  disableChannelPushNotification(e, t) {
    return this.channel.disablePushNoti(e, t);
  }
  getChannelPushNotificationSettings(e, t) {
    return this.channel.getChannelPushNotificationSettings(e, t);
  }
  updateChannelPushNotificationSettings(e, t) {
    return this.channel.updateChannelPushNotificationSettings(
      e,
      t
    );
  }
  markChannelAsRead(e, t) {
    return this.channel.markChannelAsRead(e, t);
  }
  /**
   * @deprecated Use markChannelAsRead() instead
   */
  markAsRead(e, t) {
    return this.channel.markChannelAsRead(e, t);
  }
  markAllChannelsAsRead(e) {
    return this.channel.markAllChannelsAsRead(e);
  }
  /**
   * @deprecated Use markAllChannelsAsRead() instead
   */
  markAsReadAllChannel(e) {
    return this.channel.markAllChannelsAsRead(e);
  }
  getMessages(e, t) {
    return this.channel.getMessages(e, t);
  }
  getFileMessages(e, t) {
    return this.channel.getFileMessages(e, t);
  }
  sendMessage(e, t) {
    return this.channel.sendMessage(e, t);
  }
  translateMessage(e, t) {
    return this.channel.translateMessage(e, t);
  }
  getMessage(e, t) {
    return this.channel.getMessage(e, t);
  }
  deleteMessage(e, t) {
    return this.channel.deleteMessage(e, t);
  }
  addMessageReaction(e, t) {
    return this.channel.addMessageReaction(e, t);
  }
  removeMessageReaction(e, t) {
    return this.channel.removeMessageReaction(e, t);
  }
  updateChannelPrivateTag(e, t) {
    return this.channel.updateChannelPrivateTag(e, t);
  }
  updateChannelPrivateData(e, t) {
    return this.channel.updateChannelPrivateData(e, t);
  }
  updateChannelMemberInfo(e, t) {
    return this.channel.updateChannelMemberInfo(e, t);
  }
  freezeChannel(e, t) {
    return this.channel.freezeChannel(e, t);
  }
  unfreezeChannel(e, t) {
    return this.channel.unfreezeChannel(e, t);
  }
  hideChannel(e, t) {
    return this.channel.hideChannel(e, t);
  }
  showChannel(e, t) {
    return this.channel.showChannel(e, t);
  }
  hideAllChannels(e) {
    return this.channel.hideAllChannels(e);
  }
  joinChannel(e, t) {
    return this.channel.joinChannel(e, t);
  }
  joinChannelByInvitationCode(e, t) {
    return this.channel.joinChannelByInvitationCode(e, t);
  }
  leaveChannel(e, t) {
    return this.channel.leaveChannel(e, t);
  }
  getUnreadCount(e, t) {
    return this.channel.getUnreadCount(e, t);
  }
  transferChannelOwnership(e, t) {
    return this.channel.transferChannelOwnership(e, t);
  }
  getMessageUnreadCount(e) {
    return this.channel.getMessageUnreadCount(e);
  }
  /*
      --------------
      CHANNEL end
      --------------
     */
  async makeCall(e, t) {
    if (!e.channelId)
      throw Error("MissingChannelId");
    if (!e.calleeId)
      throw Error("MissingCalleeId");
    if (this.isInCall() && this.endCurrentCallIfAny(), this.rtcPeerUuid = crypto.randomUUID(), this.rtcPeerChannelId = e.channelId, this.rtcPeerCallerId = this.userId, this.rtcPeerCalleeId = e.calleeId, await this.createRtcPeerConn(), e.mediaStream)
      await this.addTracksFromMediaStream(e.mediaStream);
    else {
      const i = await this.createMediaStreamFromConstraints(e.constraints);
      await this.addTracksFromMediaStream(i);
    }
    this.__makeOffer(e.customData);
    const r = {
      channelId: this.rtcPeerChannelId,
      callerId: this.rtcPeerCallerId,
      calleeId: this.rtcPeerCalleeId
    };
    return t ? t(r) : r;
  }
  isInCall() {
    return !!this.rtcPeerUuid && !!this.rtcPeerChannelId;
  }
  async createMediaStreamFromConstraints(e) {
    let t;
    return e ? t = await navigator.mediaDevices.getUserMedia(e) : t = await navigator.mediaDevices.getUserMedia({
      video: !0,
      audio: !0
    }), t;
  }
  __makeOffer(e) {
    var i;
    const t = this.wsConn, r = this.rtcPeerConn;
    (i = this.rtcPeerConn) == null || i.createOffer({
      iceRestart: !0,
      offerToReceiveAudio: !0,
      offerToReceiveVideo: !0
    }).then((o) => {
      r == null || r.setLocalDescription(o).then(() => {
        const a = JSON.stringify({
          type: L.Offer,
          uuid: this.rtcPeerUuid,
          channelId: this.rtcPeerChannelId,
          callerId: this.rtcPeerCallerId,
          calleeId: this.rtcPeerCalleeId,
          payload: o,
          customData: e
        });
        this.__sendWs(t, a);
      }).catch((a) => {
      });
    }).catch((o) => {
      console.error(o);
    });
  }
  async addTracksFromMediaStream(e) {
    var r;
    const t = e == null ? void 0 : e.getTracks();
    if (t.length && !(!this.rtcPeerConn || this.rtcPeerConn.connectionState === "closed"))
      for (const i of t)
        (r = this.rtcPeerConn) == null || r.addTrack(i, e);
  }
  async createRtcPeerConn() {
    let e;
    try {
      e = await this.auth.getWebRTCAuth();
    } catch {
      return;
    }
    const { stunServerUris: t, turnServerUris: r, turnUsername: i, turnPassword: o } = e, a = [];
    for (const l of t)
      a.push({
        urls: l
      });
    for (const l of r)
      a.push({
        urls: l,
        username: i,
        credential: o
      });
    this.rtcPeerConn = new RTCPeerConnection({
      iceServers: a
    }), !(!this.rtcPeerChannelId || !this.rtcPeerCalleeId) && (this.rtcPeerConn.onnegotiationneeded = (l) => {
      this.rtcPeerIncomingOfferPayload || this.__makeOffer();
    }, this.rtcPeerConn.onicecandidate = (l) => {
      var u;
      if (!l.candidate)
        return;
      if (!this.rtcPeerConnectionInProgress) {
        (u = this.rtcPeerIceCandidates) == null || u.push(l.candidate);
        return;
      }
      const h = JSON.stringify({
        type: L.Candidate,
        uuid: this.rtcPeerUuid,
        channelId: this.rtcPeerChannelId,
        callerId: this.rtcPeerCallerId,
        calleeId: this.rtcPeerCalleeId,
        payload: l.candidate
      });
      this.__sendWs(this.wsConn, h);
    }, this.rtcPeerConn.onconnectionstatechange = (l) => {
      var h, u;
      this.call.emit(
        "statechanged",
        {
          channelId: this.rtcPeerChannelId,
          callerId: this.rtcPeerCallerId,
          calleeId: this.rtcPeerCalleeId,
          state: (h = l.currentTarget) == null ? void 0 : h.connectionState
        }
      ), ((u = l.currentTarget) == null ? void 0 : u.connectionState) === "failed" && (this.call.emit("failed", {
        channelId: this.rtcPeerChannelId,
        callerId: this.rtcPeerCallerId,
        calleeId: this.rtcPeerCalleeId
      }), this.resetWebRTCDetails());
    }, this.rtcPeerConn.ontrack = (l) => {
      this.rtcPeerConnectionMade = !0, this.call.emit("connected", {
        channelId: this.rtcPeerChannelId,
        callerId: this.rtcPeerCallerId,
        calleeId: this.rtcPeerCalleeId,
        trackEvent: l,
        customData: this.rtcPeerIncomingCustomData
      });
    });
  }
  handleWebRTCIceCandidate(e) {
    var i;
    if (e.uuid !== this.rtcPeerUuid)
      return;
    const t = e.payload;
    if (!this.rtcPeerConn) {
      console.error("rtc peer conn not available");
      return;
    }
    const r = new RTCIceCandidate(t);
    (i = this.rtcPeerConn) == null || i.addIceCandidate(r).then(() => {
    }).catch((o) => {
    });
  }
  endCurrentCallIfAny() {
    if (this.isInCall()) {
      const e = JSON.stringify({
        type: L.EndCall,
        uuid: this.rtcPeerUuid,
        channelId: this.rtcPeerChannelId,
        callerId: this.rtcPeerCallerId,
        calleeId: this.rtcPeerCalleeId,
        endReasonCode: F.Declined,
        endReasonMessage: B.Declined
      });
      this.__sendWs(this.wsConn, e);
    }
  }
  async handleWebRTCOffer(e) {
    if (this.isInCall()) {
      const h = JSON.stringify({
        type: L.EndCall,
        uuid: e.uuid,
        channelId: e.channelId,
        callerId: e.callerId,
        calleeId: e.calleeId,
        endReasonCode: F.Declined,
        endReasonMessage: B.Declined
      });
      this.__sendWs(this.wsConn, h);
      return;
    }
    const { uuid: t, channelId: r, callerId: i, calleeId: o, payload: a, customData: l } = e;
    this.rtcPeerUuid = t, this.rtcPeerChannelId = r, this.rtcPeerCallerId = i, this.rtcPeerCalleeId = o, this.rtcPeerIncomingOfferPayload = a, await this.createRtcPeerConn(), this.call.emit("incoming", {
      channelId: r,
      callerId: i,
      calleeId: o,
      customData: l
    });
  }
  async acceptCall(e, t) {
    var i;
    if (!this.rtcPeerIncomingOfferPayload)
      throw Error("NoCallToReceive");
    if (e.mediaStream)
      await this.addTracksFromMediaStream(e.mediaStream);
    else {
      const o = await this.createMediaStreamFromConstraints(e.constraints);
      await this.addTracksFromMediaStream(o);
    }
    await ((i = this.rtcPeerConn) == null ? void 0 : i.setRemoteDescription(new RTCSessionDescription(this.rtcPeerIncomingOfferPayload))), await this.sendAnswer(e.customData), this.rtcPeerConnectionInProgress = !0, this.sendSavedIceCandidates();
    const r = {
      channelId: this.rtcPeerChannelId || "",
      callerId: this.rtcPeerCallerId || "",
      calleeId: this.rtcPeerCalleeId || ""
    };
    return t ? t(r) : r;
  }
  async sendAnswer(e) {
    var i, o;
    const t = await ((i = this.rtcPeerConn) == null ? void 0 : i.createAnswer());
    if (!t) {
      console.error("TalkPlus client. unable to create peer answer");
      return;
    }
    (o = this.rtcPeerConn) == null || o.setLocalDescription(
      new RTCSessionDescription(t)
    ).catch((a) => {
      console.error(a);
    });
    const r = JSON.stringify({
      type: L.Answer,
      uuid: this.rtcPeerUuid,
      channelId: this.rtcPeerChannelId,
      callerId: this.rtcPeerCallerId,
      calleeId: this.rtcPeerCalleeId,
      payload: t,
      customData: e
    });
    this.__sendWs(this.wsConn, r);
  }
  endCall(e) {
    if (!this.rtcPeerUuid)
      throw new Error("NoCallInProgress");
    let t = {
      channelId: this.rtcPeerChannelId,
      callerId: this.rtcPeerCallerId,
      calleeId: this.rtcPeerCalleeId,
      endReasonCode: F.Completed,
      endReasonMessage: B.Completed
    }, r = {
      type: L.EndCall,
      uuid: this.rtcPeerUuid,
      channelId: this.rtcPeerChannelId,
      callerId: this.rtcPeerCallerId,
      calleeId: this.rtcPeerCalleeId,
      endReasonCode: F.Completed,
      endReasonMessage: B.Completed
    };
    this.rtcPeerIncomingOfferPayload && !this.rtcPeerConnectionMade ? (r.endReasonCode = F.Declined, r.endReasonMessage = B.Declined, t.endReasonCode = F.Declined, t.endReasonMessage = B.Declined) : this.rtcPeerConnectionMade || (r.endReasonCode = F.Canceled, r.endReasonMessage = B.Canceled, t.endReasonCode = F.Canceled, t.endReasonMessage = B.Canceled), this.__sendWs(this.wsConn, JSON.stringify(r));
    const i = {
      channelId: this.rtcPeerChannelId || "",
      callerId: this.rtcPeerCallerId || "",
      calleeId: this.rtcPeerCalleeId || ""
    };
    return this.handleCallEndedEvent(t), e ? e(i) : i;
  }
  __sendWs(e, t) {
    try {
      e == null || e.send(t);
    } catch {
    }
  }
  handleWebRTCAnswer(e) {
    var r;
    if (e.uuid !== this.rtcPeerUuid) {
      const i = JSON.stringify({
        type: L.EndCall,
        uuid: e.uuid,
        channelId: e.channelId,
        callerId: e.callerId,
        calleeId: e.calleeId,
        endReasonCode: F.Canceled,
        endReasonMessage: B.Canceled
      });
      this.__sendWs(this.wsConn, i);
      return;
    }
    this.rtcPeerConnectionInProgress = !0, this.sendSavedIceCandidates(), this.rtcPeerIncomingCustomData = e.customData;
    const t = e.payload;
    (r = this.rtcPeerConn) == null || r.setRemoteDescription(new RTCSessionDescription(t)).then(() => {
    });
  }
  sendSavedIceCandidates() {
    if (this.rtcPeerIceCandidates) {
      for (const e of this.rtcPeerIceCandidates) {
        const t = JSON.stringify({
          type: L.Candidate,
          uuid: this.rtcPeerUuid,
          channelId: this.rtcPeerChannelId,
          callerId: this.rtcPeerCallerId,
          calleeId: this.rtcPeerCalleeId,
          payload: e
        });
        this.__sendWs(this.wsConn, t);
      }
      this.rtcPeerIceCandidates = [];
    }
  }
  handleWebRTCEndCall(e) {
    if (!this.rtcPeerUuid || this.rtcPeerUuid !== e.uuid)
      return;
    const t = {
      channelId: e.channelId,
      callerId: e.callerId,
      calleeId: e.calleeId,
      endReasonCode: e.endReasonCode,
      endReasonMessage: e.endReasonMessage
    };
    this.handleCallEndedEvent(t);
  }
  handleCallEndedEvent(e) {
    this.call.emit("ended", e), this.resetWebRTCDetails();
  }
  resetWebRTCDetails() {
    var e;
    (e = this.rtcPeerConn) == null || e.close(), this.rtcPeerUuid = void 0, this.rtcPeerChannelId = void 0, this.rtcPeerCallerId = void 0, this.rtcPeerCalleeId = void 0, this.rtcPeerIncomingOfferPayload = void 0, this.rtcPeerIncomingCustomData = void 0, this.rtcPeerConnectionInProgress = !1, this.rtcPeerConnectionMade = !1, this.rtcPeerIceCandidates = [];
  }
}
export {
  oe as ChannelQueryFilterEnum,
  V as ChannelQueryTypeEnum,
  ks as ChannelTypeEnum,
  vs as Client,
  Os as EventTypeEnum,
  _s as MessageTypeEnum,
  F as WebRTCEndCallReasonEnum,
  B as WebRTCEndCallReasonMsgEnum,
  L as WebRTCEventTypeEnum
};
